// @ts-ignore
import {
  AfterViewInit,
  ChangeDetectorRef, Component,
  ElementRef,
  Input,


  OnDestroy, OnInit,
  ViewChild
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
// @ts-ignore
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
import { first, map, switchMap, tap } from 'rxjs/operators';
import { Message } from 'src/app/core/class/message';
import { CertificateTypeID } from 'src/app/core/constants/common';
import { EnterpriseTypes } from 'src/app/core/constants/enterprise-type';
import { ApiService } from 'src/app/core/services/api.service';
import { CanvasService } from 'src/app/core/services/canvas.service';
import { CommonService } from 'src/app/core/services/common.service';
import { DigitalCertificateService } from 'src/app/core/services/digital-certificate.service';
import { DocumentService } from 'src/app/core/services/document.service';
import { EnvService } from 'src/app/core/services/env.service';
import { SignDocumentService } from 'src/app/core/services/sign-document.service';
import { SigningDialogComponent } from 'src/app/modules/dashboard/home/home-enterprise/document/signing-dialog/signing-dialog.component';
import { AlertComponent } from 'src/app/shared/components/alert/alert.component';
import { BreadcrumbsService } from 'src/app/shared/components/breadcrumbs/breadcrumbs.service';
import { CanvasComponent } from 'src/app/shared/components/canvas/canvas.component';
import { NotifyWarningComponent } from 'src/app/shared/components/notify-warning/notify-warning.component';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import * as uuid from 'uuid';
import { Common } from '../../../core/constants/common';
import { EnumContractEnterpriseStatus, EnumSignMethod } from "../../../core/constants/contract";
import { ErrorCode } from '../../../core/constants/error-code';
import { SCREEN_SIZE } from '../../../core/constants/screen-size';
import { SignPositionTypes } from '../../../core/constants/signposition-types';
import { AnonymousSignService } from '../../../core/services/anonymous-sign.service';
import { ImageGenerateService } from "../../../core/services/image-generate.service";
import { NotificationService } from '../../../core/services/notification.service';
import { ResponsiveService } from '../../../core/services/responsive.service';
import { CloudCaProvider } from "../../dashboard/home/home-enterprise/digital-certificate/add-digital-certificate/add-digital-certificate.component";
import { ConfirmResignEkycSupportComponent } from '../../dashboard/home/home-enterprise/document/confirm-resign-ekyc-support/confirm-resign-ekyc-support.component';
import { ConfirmSignOtpWithImageComponent } from '../../dashboard/home/home-enterprise/document/confirm-sign-otp-with-image/confirm-sign-otp-with-image.component';
import { EkycCameraComponent } from '../../dashboard/home/home-enterprise/document/ekyc/ekyc-camera/ekyc-camera.component';
import { SignDocumentComponent } from '../../dashboard/home/home-enterprise/document/sign-document/sign-document.component';
import {
  imageConfigFormPreviewId, imageConfigRenderId,
  imageConfigViewScaleId, ImageSignConfigComponent
} from "../../dashboard/home/home-enterprise/document/sign-flow-document/image-sign-config/image-sign-config.component";
import { SignatureConfig } from "../../dashboard/home/home-enterprise/document/sign-flow-document/signature-config.model";
import { format } from 'date-fns';

declare var $: any;

declare function initPluginCertificate(comp: any): any;

declare function signHash(comp, hashBase64): any;

declare function initPlugin(comp): any;

declare function initPluginCertificateNormal(comp: any): any;

declare function anonymousSignHashAsyncNew(comp, hashBase64, sessionId, serialNumber): any;


@Component({
  selector: 'app-anonymous-sign-flow',
  templateUrl: './anonymous-sign-flow.component.html',
  styleUrls: ['./anonymous-sign-flow.component.scss']
})
export class AnonymousSignFlowComponent implements OnInit, OnDestroy, AfterViewInit {
  // @ts-ignore
  @ViewChild(ImageSignConfigComponent) imageSignConfig: ImageSignConfigComponent;
  // @ts-ignore
  @ViewChild('SignImageConfig', {static: true}) domRenderImage: ElementRef
  public listPdfSrc = {};
  public isCancelSign = false;
  private processingId: string = null;
  isCheckAccessToContract = true;
  contractSignEntityList: [];
  businessType: number = 2;
  signImages = [];
  signTransactionId: any
  userCancel = false;
  signingInteval: any
  BASE_URL = 'http://localhost:8091/api';
  isError: boolean = false;
  blockUIStop: boolean = false;
  isNotAttestedUser: boolean = false;
  isSignDigitalCertificate = false;

  signConfig: SignatureConfig = SignatureConfig.build();
  widthImageRender: number = 0;
  heightImageRender: number = 0;
  scopeType = 0;

  maxLengthPhone = Common.MAX_LENGTH_PHONE;

  systemImageSign = true;
  messageSign: string;

  public subcribePreviewImage: Subscription;
  public subcribePreviewImageUrl: Subscription;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    public commonService: CommonService,
    public message: Message,
    private toastr: ToastrService,
    private digitalCertificateService: DigitalCertificateService,
    private sanitizer: DomSanitizer,
    private translateService: TranslateService,
    private activeRoute: ActivatedRoute,
    private signDocumentService: SignDocumentService,
    private breadcrumbsService: BreadcrumbsService,
    private documentService: DocumentService,
    private canvasService: CanvasService,
    private anonymousSignService: AnonymousSignService,
    private notificationService: NotificationService,
    private responsiveService: ResponsiveService,
    public deviceService: DeviceDetectorService,
    private apiService: ApiService,
    private env: EnvService,
    private cd: ChangeDetectorRef,
    private imageGenerateService: ImageGenerateService
  ) {
    this.isNotAttestedUser = this.commonService.checkEnterpriseAnonymusType();
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.isShowSidebarButton = false;
      this.zoomLevel = 50;
    }
    this.BASE_URL = env.is_private_app ? env.private_api_endpoint : env.public_api_endpoint;
    this.BASE_URL += '/anonymous/file-detail-no-file-path';

    const listEnterprise = JSON.parse(localStorage.getItem('AnonymousListEnterprise'));
    this.businessType = listEnterprise.enterpriseSign[0] ? listEnterprise.enterpriseSign[0].businessType : 2
    const enterpriseChoose = listEnterprise.enterpriseSign.filter(enter => enter.status === EnumContractEnterpriseStatus.PROCESSING || enter.status === EnumContractEnterpriseStatus.WAIT_SETUP_FLOW);
    this.userType = Number(localStorage.getItem('userType'));
    this.enterpriseId = localStorage.getItem('enterpriseId');
    if (enterpriseChoose) {
      if (listEnterprise.enterpriseSignIdInFlow) {
        enterpriseChoose.map(enter => {
          if (enter.enterpriseId === listEnterprise.enterpriseSignIdInFlow || enter.customerId === listEnterprise.enterpriseSignIdInFlow) {
            this.enterpriseName = enter.enterpriseName;
          }
        });
      } else {
        this.enterpriseName = enterpriseChoose[0].enterpriseName || localStorage.getItem('fullName');
      }
    } else {
      this.enterpriseName = localStorage.getItem('fullName');
    }
    const enterpriseProcessing = listEnterprise.enterpriseSign.find(enter => enter.isCurrent);
    // console.log(enterpriseProcessing);
    this.canMoveAndResize = enterpriseProcessing && enterpriseProcessing.signConfig ? JSON.parse(enterpriseProcessing.signConfig).resize : false;
    // console.log(this.canMoveAndResize);
    this.language = localStorage.getItem('__language') || 'vi';
    this.subscriptions.add(
      this.signDocumentService.openSigningDialog.asObservable().subscribe(rs => {
        this.openSigningDialog = rs
      })
    );
  }

  public language: string;
  private isClickSignBuuton = false;
  public isShowSidebarButton = true;
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public subscribeViewLandscapeService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE
  public isAllowSelectSignPosition = true;

  errorFormatTypeFile = false;
  maxSizeInput = false;
  usbTokenCertificate = {
    certRawdata: '',
    taxCode: '',
    serialNumber: '',
    issuedTo: '',
    issuedBy: '',
    expireDate: new Date(),
    activeDate: new Date(),
    fileName: '',
    certificateName: '',
    distinguishedName: '',
    email: ''
  };
  subscriptions: Subscription = new Subscription();
  @ViewChild('inputUpload', {read: '', static: false}) inputUploadFile: ElementRef;
  private imagePreviewWidth: number;
  private imagePreviewHeight: number;
  openSigningDialog = false
  private hashKey: string;
  private tenantId: string;
  private contractIdAndContractEnterpriseIdEncode: string = null;
  listOfDataSimCa: SimCaDataItem[] = [];
  cloudCaDataSource: CloudCaDataItem[] = [];
  isOutOfSmsMoney: boolean = false;
  private leftPosition: number;
  page: number;
  pageSize: number;
  routeLink: string;
  enterprise: '';
  documentTypeSearch: '';
  nameOrCode: '';
  status: '';
  serviceType: '';
  serviceTypeEntity: any;
  taxCode: '';
  createdUser: '';
  createdTimeFrom: '';
  createdTimeTo: '';
  finishDateFrom: '';
  finishDateTo: '';
  sortDirection: '';
  sortColumn: '';
  goFrom: string;
  public document: any;
  private customerName: '';
  selectedImage: File;
  isShowImage = true;
  selectedImageUrl: string | ArrayBuffer;
  isDisableNextButton = true;
  private indexSelect: number = 0;
  public signPosition: any[];
  private isSelectedCertSource = new BehaviorSubject(false);
  isSelectedCert = this.isSelectedCertSource.asObservable();
  validateInfo: any[];
  certificateType = EnumSignMethod;
  checkAgree: boolean = false;
  private isGotoSignpage = false;
  private sign: any;
  private contractId: string;
  private certificate = {
    serialNumber: '',
    phoneNumber: undefined,
    typeCertificate: undefined,
    id: undefined,
    idDetail: undefined
  };
  private success: boolean;
  public enterpriseName: string;
  private imageData = [];

  public imageUrlPreview: any;

  private pageIndex = 0;
  private isSelectPosition: any;
  private stampWrapper: HTMLDivElement;
  widthRectangle = 300;
  heightRectangle = 136;
  private signPage: any;

  private isSelectDrawImage = false;
  public fileUpload: File;
  public loading: boolean;
  public avatarUrl: string;

  current = 0;

  saveImageData = []

  index = 'First-content';
  typeCertificate: number;
  public selectedCert = {
    serialNumber: '',
    phoneNumber: undefined,
    typeCertificate: undefined,
    id: undefined,
    idDetail: undefined,
    imageUrl: null,
    issuedTo: '',
    certificateName: '',
    cloudCaUserId: '',
    taxCode: '',
    email: ''
  };
  public disableBtnDeleteCanvas: boolean;
  public signMethod = {
    SIGN_SERVER: 0,
    SIGN_USB_TOKEN: 1,
    SIGN_SIM_CA: 2,
    SIGN_OTP: 3,
    // SIGN_HSM: 4,
    // SIGN_IMAGE: 5,
    SIGN_NO_CERT: 6,
    SIGN_EKYC: 7,
    SIGN_EKYC_ADVANCED: 8,
    CLOUD_CA: 10
  };
  private userType: number;
  private enterpriseId: string;
  @Input() public canvasWidth = 660;
  @Input() public canvasHeight = 300;
  pdfSrc: string;
  zoomLevel = 100;
  currentDate = new Date();
  @ViewChild('myCanvas', {static: false}) canvas: ElementRef;
  @ViewChild('navigation', {static: false}) navigation: ElementRef;
  @ViewChild('btnView', {static: false}) private btnView: ElementRef<HTMLElement>;

  // @ts-ignore
  @ViewChild(CanvasComponent) canvasComponent;

  @BlockUI() blockUI: NgBlockUI;

  thumbnail = [];
  canMoveAndResize: boolean = false;

  beforeUpload = this.commonService.beforeUploadImage;
  isVisible = false;
  dateNow = format(new Date(), 'DD/MM/YYYY');
  codeError: boolean;
  typeSelectCertificate: number;
  simCaPhoneNumber = '';
  private selectedCertSimCa: any;
  valueSelectUploadUsb = 1;
  checkFocus: boolean;
  errorStatus: string;
  errorInitPlugin: boolean;
  pageCurrent = 1;
  sessionId: string;
  certData: string;

  signDataValidate;
  otpPhoneNumber = '';
  otpPhoneNumberMaxLength = Common.PHONE_MAXLENGTH;
  otpPhoneNumberPattern = Common.PHONE_PATTERN3;
  private dialogRef: any;
  listEnterprise;
  enterpriseSignIdInFlow;
  signPositionTypes = SignPositionTypes;
  onlyDigital = false;

  slideButtonConfig = {
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    autoplay: false,
    autoplaySpeed: 6000,
    focusOnSelect: false,
  };

  isVisibleModalDrawSignature = false;

  fileSrc: any[] = [];
  activeFile: number = 0;
  fileError: string[] = [];
  signPositionCache: any[] = [];
  signProcessing: any[] = [];
  isCancel: boolean = false;
  isCallDone: boolean = false;
  signError: string = null;

  private linkDownSignPlugin(os?: string) {
    let OSName = os;
    if (typeof (os) === 'undefined') {
      if (navigator.appVersion.indexOf("Win") != -1) OSName = "WINDOWS";
      if (navigator.appVersion.indexOf("Mac") != -1) OSName = "MACOS";
      if (navigator.appVersion.indexOf("X11") != -1) OSName = "UNIX";
      if (navigator.appVersion.indexOf("Linux") != -1) OSName = "LINUX";
    }
    return this.apiService.getBaseUrl() + `/file/download-last-version?os=${OSName}&typeFile=${OSName === "WINDOWS" ? 'exe' : OSName === "LINUX" ? 'deb' : 'pkg'}`;
  };

  providerName = '';
  providerId: number;
  cloudCaUsername: string;
  isViewLandscape: boolean = false;
  currentPhone: string;
  isShowEKYC: boolean = false;
  supportEkyc: boolean = false;
  isReloadCamera = true;
  serviceTypeData: any = null;
  isCertificateSupport: boolean = false;
  isPassport: boolean = false;
  certificateTypeID = CertificateTypeID;
  isPersonal: boolean = false;
  ekycSupportConfig: number = null;
  allowOtp: boolean = false;
  isStillQuantityEkyc: boolean = false;
  isQuantityEkyc: boolean = false;
  isQuantityAdvancedEkyc: boolean = false;
  @ViewChild(EkycCameraComponent, {static: false}) private ekyc;

  lstCloudCaProvider: CloudCaProvider[];


  ngOnInit() {
    // this.anonymousSignService.getSignDataValidate().subscribe((validate: any) => {
    //   this.signDataValidate = validate;
    // });
    this.signDataValidate = JSON.parse(localStorage.getItem('SignDataValidate') || '{}');
    this.otpPhoneNumber = this.signDataValidate.phoneNumber;
    this.signConfig.phoneNumber.value = this.otpPhoneNumber;
    if (+this.signDataValidate.certificateId === CertificateTypeID.HO_CHIEU) {
      this.isPassport = true;
    } else if (+this.signDataValidate.certificateId === CertificateTypeID.CCCD || +this.signDataValidate.certificateId === CertificateTypeID.CMTND) {
      this.isPassport = false;
    }

    if (+this.signDataValidate.certificateId === CertificateTypeID.CCCD
      || +this.signDataValidate.certificateId === CertificateTypeID.CMTND
      || +this.signDataValidate.certificateId === CertificateTypeID.HO_CHIEU) {
      this.isCertificateSupport = true;
    }
    this.listEnterprise = JSON.parse(localStorage.getItem('AnonymousListEnterprise')).enterpriseSign;
    this.enterpriseSignIdInFlow = JSON.parse(localStorage.getItem('AnonymousListEnterprise')).enterpriseSignIdInFlow;
    this.listEnterprise.map(enter => {
      // trạng thái đang xử lý
      if (enter.status === EnumContractEnterpriseStatus.PROCESSING || enter.status === EnumContractEnterpriseStatus.WAIT_SETUP_FLOW) {
        // Luồng KCT không có enterpriseId thay bằng customerId
        if (
          enter.enterpriseId === JSON.parse(localStorage.getItem('AnonymousListEnterprise')).enterpriseSignIdInFlow ||
          enter.customerId === JSON.parse(localStorage.getItem('AnonymousListEnterprise')).enterpriseSignIdInFlow
        ) {
          // type = 2 là khách hàng cá nhân, type !=2 thì không hiển thị OTP và ký ảnh
          if (enter.enterpriseType === EnterpriseTypes.PERSONAL) {
            this.isPersonal = true;
          }
        }
      }
    });

    this.route.paramMap.subscribe(params => {
      this.hashKey = params.get('hashKey');
      this.tenantId = params.get('tenantId');
      this.contractIdAndContractEnterpriseIdEncode = params.get('contractIdAndContractEnterpriseIdEncode') ? params.get('contractIdAndContractEnterpriseIdEncode') : null;
    });
    this.route.queryParams.subscribe(params => {
      this.messageSign = params.message ? params.message : '';
    });
    // this.viewDocumentsUpload();
    this.notificationService.subscribeErrorService();
    this.subscribeValue();
    this.getDocument();
    this.viewDocumentsUpload();
    this.commonService.getCurrentLanguage().subscribe(lang => {
      if (lang !== this.language) {
        location.reload();
      }
    });

    this.commonService.getAllCloudCaProvider().subscribe(rs => {
      if (rs && rs.data) {
        this.lstCloudCaProvider = rs.data;
        this.providerName = this.lstCloudCaProvider[0].name;
        this.providerId = this.lstCloudCaProvider[0].id;

      }
    })

    this.getUserConfig();
  }

  ngAfterViewInit() {
    this.typeSelectCertificate = this.signMethod.SIGN_SIM_CA;
    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          // isDesktop thì fix width khung vẽ ở các cỡ màn khác nhau:
          if (this.deviceService.isDesktop()) {
            this.mediaBreakpoint = media;
            switch (this.mediaBreakpoint) {
              case SCREEN_SIZE.XS:
                this.canvasWidth = 320;
                this.canvasHeight = Math.round(320 * (136 / 300));
                break;
              case SCREEN_SIZE.SM:
                this.canvasWidth = 345;
                this.canvasHeight = Math.round(345 * (136 / 300));
                break;
              case SCREEN_SIZE.MD:
                this.canvasWidth = 450;
                break;
              case SCREEN_SIZE.XL:
                this.canvasWidth = 470;
                break;
              default:
                this.canvasWidth = 660;
                break;
            }
          }
          // console.log("this.mediaBreakpoint: ", this.mediaBreakpoint);
        }
      }
    );

    this.subscribeViewLandscapeService = this.responsiveService.getView().subscribe(isLandscape => {
      this.isViewLandscape = isLandscape;
    });

    // const isMobile = this.deviceService.isMobile();
    // console.log("isMobile: ", isMobile);
    // const isTablet = this.deviceService.isTablet();
    // console.log("isTablet: ", isTablet);
    // const isDesktopDevice = this.deviceService.isDesktop();
    // console.log("isDesktopDevice: ", isDesktopDevice);
  }

  ngOnDestroy(): void {
    this.notificationService.unsubscribeErrorService();
    this.subscribeMediaBreakPointService.unsubscribe();
    this.canvasService.setCanvasImageUrl('')
    this.canvasService.setCanvasImage(null)
    this.subcribePreviewImageUrl.unsubscribe();
    this.subcribePreviewImage.unsubscribe();
    this.isSelectDrawImage = false;
    this.isDisableNextButton = false;
    this.fileUpload = null;
    this.systemImageSign = false;
    this.imageUrlPreview = null;
    this.selectedImage = null
  }

  handlePreview = async (file: NzUploadFile) => {
    if (!file.url && !file.preview) {
      // tslint:disable-next-line:no-non-null-assertion
      file.preview = await this.commonService.getBase64(file.originFileObj!);
    }
  }

  onMouseClickPdfViewer() {
    this.isSelectPosition = false;
  }

  pre(): void {
    if (this.contractIdAndContractEnterpriseIdEncode) {
      this.checkExpireTime();
    }
    this.getDocument();
    this.current -= 1;
    this.indexSelect = 0;
    this.nzSelectChange(this.indexSelect);
    if (this.current < 2) {
      const firstFile = this.document.mainContractAttachments[0];
      this.activeFile = 0;
      this.pdfSrc = this.listPdfSrc[firstFile.path];
      this.isSelectPosition = false;
      this.isAllowSelectSignPosition = false;
      const nodeOther = document.getElementById('show-frames-notification');
      if (nodeOther) {
        nodeOther.remove();
      }
    }

    if (this.current === 1) {
      this.avatarUrl = null;
      this.isSelectDrawImage = false;
      this.fileUpload = this.selectedImage;
      this.imageUrlPreview = this.selectedImageUrl;
      if (this.selectedCert.typeCertificate === this.signMethod.SIGN_NO_CERT) {
        this.isDisableNextButton = true;
      }

      if (this.systemImageSign && this.indexSelect === 0) {
        setTimeout(() => {
          this.setFontSize(imageConfigViewScaleId);
        }, 100);
      }
      this.nzSelectChange(0);
    }

    if (this.current === 0) {
      this.otpPhoneNumber = this.currentPhone
      this.isSelectDrawImage = false;
      this.fileUpload = null;
      this.imageUrlPreview = '';
      this.avatarUrl = null;
      if (this.selectedCert) {
        this.isDisableNextButton = false;
      }
    }
    // console.log(this.current)
  }

  decodeTaxCode(taxCode: string): string {
    const arrs = taxCode.split(",");
    for (let element of arrs) {
      if (element.trim().startsWith("MST") || element.trim().startsWith("CMND") || element.trim().startsWith("CCCD")) {
        return element.split(":")[1];
      }
    }
    return "";
  }

  async next() {
    if (this.contractIdAndContractEnterpriseIdEncode) {
      this.checkExpireTime();
    }
    if (this.current === 0 && (this.typeCertificate === this.signMethod.SIGN_OTP
      || this.typeCertificate === this.signMethod.SIGN_EKYC
      || this.typeCertificate === this.signMethod.SIGN_EKYC_ADVANCED)) {
      if (this.digitalCertificateService.formatPhoneNumber(this.otpPhoneNumber).trim().length < 11
        || this.digitalCertificateService.formatPhoneNumber(this.otpPhoneNumber).trim().length >= 15) {
        this.toastr.error(this.message.getMessage('lading_page.main.contact.validate_form.otp_phone_min_length'));
        return;
      }
    }
    // check simCA hoặc Usb token

    if (this.typeCertificate === this.signMethod.SIGN_SIM_CA
      || this.typeCertificate === this.signMethod.SIGN_USB_TOKEN
      || this.typeCertificate === this.signMethod.CLOUD_CA) {
      if (this.typeCertificate === this.signMethod.SIGN_SIM_CA
        || this.typeCertificate === this.signMethod.CLOUD_CA) {
        if (this.signDataValidate != null) {
          // check mã số thuế
          if (this.signDataValidate.checkCertNumber) {
            // const taxCode = this.selectedCertSimCa.taxCode;
            // const validateInfo = this.decodeTaxCode(taxCode);


            if (this.selectedCert.taxCode.length > 0 &&
              (this.selectedCert.taxCode.toUpperCase() === this.signDataValidate.certificateNo.toUpperCase() ||
                (this.signDataValidate.representDocumentNumber && this.selectedCert.taxCode.toUpperCase() === this.signDataValidate.representDocumentNumber.toUpperCase()) ||
                (this.signDataValidate.taxCode && this.selectedCert.taxCode.toUpperCase() === this.signDataValidate.taxCode.toUpperCase()))) {
              // next step
            } else {
              this.toastr.error(this.message.getMessage('messages.digital_certificate_validate_taxCode'));
              return false;
            }
          }
          // check name
          if (this.signDataValidate.checkName) {
            // status = 2 là đang xử lý
            const enterpriseProcessing = this.listEnterprise.filter(enter => enter.status === 2 || enter.status === 6);
            const enterpriseName = enterpriseProcessing[0].enterpriseName;
            if (enterpriseName && (this.selectedCert.certificateName.toUpperCase() !== enterpriseName.toUpperCase())) {
              this.toastr.error(this.message.getMessage('messages.digital_certificate_validate_name'));
              return false;
            }
          }
        }
      } else {
        if (this.signDataValidate) {
          if (this.signDataValidate.checkCertNumber) {
            const taxCode = this.usbTokenCertificate.taxCode;
            const validateInfo = this.decodeTaxCode(taxCode);
            if (validateInfo.length > 0 && (validateInfo.toUpperCase() === this.signDataValidate.certificateNo.toUpperCase() ||
              (this.signDataValidate.representDocumentNumber && validateInfo.toUpperCase() === this.signDataValidate.representDocumentNumber.toUpperCase()) ||
              (this.signDataValidate.taxCode && validateInfo.toUpperCase() === this.signDataValidate.taxCode.toUpperCase()))) {
              // next step
            } else {
              this.toastr.error(this.message.getMessage('messages.digital_certificate_validate_taxCode'));
              return false;
            }
          }
          // check name
          if (this.signDataValidate.checkName) {
            // status = 2 là đang xử lý
            const enterpriseProcessing = this.listEnterprise.filter(enter => enter.status === 2 || enter.status === 6);
            const enterpriseName = enterpriseProcessing[0].enterpriseName;
            if (enterpriseName && (this.usbTokenCertificate.issuedTo.toUpperCase() !== enterpriseName.toUpperCase())) {
              this.toastr.error(this.message.getMessage('messages.digital_certificate_validate_name'));
              return false;
            }
          }
        }
      }
    }

    // check OTP
    if (this.typeCertificate === this.signMethod.SIGN_OTP) {
      if (this.signDataValidate) {
        if (this.signDataValidate.checkOtp) {
          // status = 2 là đang xử lý
          const enterpriseProcessing = this.listEnterprise.filter(enter => (enter.status === 2 || enter.status === 6) && (enter.enterpriseId === this.enterpriseSignIdInFlow || enter.customerId === this.enterpriseSignIdInFlow));
          const enterprisePhone = enterpriseProcessing[0].enterprisePhone;
          if (this.current === 0) {
            this.isDisableNextButton = false
            this.currentPhone = this.otpPhoneNumber
          }
          if (enterprisePhone && (this.digitalCertificateService.formatPhoneNumber(this.otpPhoneNumber) !== this.digitalCertificateService.formatPhoneNumber(enterprisePhone))) {
            const message = this.commonService.format(this.message.getMessage('messages.digital_certificate_validate_phone'), enterprisePhone);
            this.toastr.error(message);
            return false;
          }
        }
      }
    }
    let isNextEkyc = false;
    let isValidatedSupportCertificate = false;
    if (this.current === 0) {
      setTimeout(() => {
        this.setFontSize(imageConfigViewScaleId);
      }, 100);
      let typeSupportEKYC = this.typeSelectCertificate === this.signMethod.SIGN_OTP
        || this.typeSelectCertificate === this.signMethod.SIGN_NO_CERT;
      let isSignEkyc = this.typeSelectCertificate === this.signMethod.SIGN_EKYC
        || this.typeSelectCertificate === this.signMethod.SIGN_EKYC_ADVANCED
      if (typeSupportEKYC) {
        if (this.supportEkyc && this.isPersonal) {
          isValidatedSupportCertificate = true;
          if (+this.signDataValidate.certificateId === CertificateTypeID.CCCD
            || +this.signDataValidate.certificateId === CertificateTypeID.CMTND
            || +this.signDataValidate.certificateId === CertificateTypeID.HO_CHIEU) {
            this.isShowEKYC = true;
            isNextEkyc = await this.getQuantityEkycBeforeNext().toPromise().then()
          } else this.isShowEKYC = false;
        } else this.isShowEKYC = false;
      } else {
        if (isSignEkyc) {
          if (this.isPersonal) {
            isValidatedSupportCertificate = true;
            if (+this.signDataValidate.certificateId === CertificateTypeID.CCCD
              || +this.signDataValidate.certificateId === CertificateTypeID.CMTND
              || +this.signDataValidate.certificateId === CertificateTypeID.HO_CHIEU) {
              this.isShowEKYC = true;
              isNextEkyc = await this.getQuantityEkycBeforeNext().toPromise().then()
            } else this.isShowEKYC = false;
          } else this.isShowEKYC = false;
        } else this.isShowEKYC = false;
      }
      if (isValidatedSupportCertificate) {
        if (!this.isShowEKYC) {
          this.toastr.error(this.message.getMessage('digital_certificate_management.certificate_not_support'))
          return
        }
      }
    }
    if (this.current === 0 && this.isShowEKYC) {
      if (this.isOutOfSmsMoney) {
        this.openDialogOutOfMoneyOtp(this.message.getMessage('messages.otp_out_of_money'));
        return;
      }
    }
    if (!this.isShowImage && this.isSignDigitalCertificate) {
      this.checkTimestampMoney();
      return;
    }
    if (this.current === 0 && this.isShowEKYC && !isNextEkyc) {
      this.toastr.error(this.message.getMessage('digital_certificate_management.quantity_ekyc_not_enough'));
      return
    }

    if (this.current === 0 && this.isShowEKYC && isNextEkyc) {
      if (this.ekyc.errors.length > 0) {
        this.toastr.error(this.message.getMessage('kyc.camera_errors'));
        return
      }
    }
    if (this.current === 1) {
      if (this.systemImageSign) {
        this.setFontSize(imageConfigRenderId);
        this.setFontSize(imageConfigViewScaleId);

        await this.imageSignConfig.renderImage();
      } else if (this.isSelectDrawImage) {
        this.canvasComponent.onSaveCanvas();
      } else {
        if (this.fileUpload) {
          this.handlePreviewFromFileUpload(this.fileUpload);
        }
      }
    }
    this.current += 1;
    if (this.current === 1) {
      if (this.typeSelectCertificate === 1) { // ký bằng usb token
        this.selectedCert = {
          ...this.selectedCert,
          ...this.usbTokenCertificate
        };
      }
      if (this.selectedCert !== null) {
        this.currentPhone = this.otpPhoneNumber;
        this.handleSelectedCert();
        this.otpPhoneNumber = this.digitalCertificateService.formatPhoneNumber(this.otpPhoneNumber);
      }

      if (this.selectedCert && (this.selectedCert.issuedTo || this.selectedCert.certificateName)) {
        const issueTo = this.selectedCert.issuedTo || this.selectedCert.certificateName
        this.signConfig.enterpriseName.value = issueTo;
      } else {
        this.signConfig.enterpriseName.value = this.document.contractEnterpriseName;
      }
      this.signConfig.email = this.selectedCert.email || this.document.email || '';
    }
    // console.log("this.current: ", this.current);

    // sau khi chọn ảnh, đến trang chọn vị trí
    if (this.current === 2) {
      if (this.document && this.document.mainContractAttachments) {
        setTimeout(() => {
          const tabs = document.getElementsByClassName('tab');
          if (tabs) {
            Array.from({length: tabs.length}, (v, i) => i).forEach(index => {
              const tab = tabs.item(index) as HTMLElement;
              tab.style.width = 100 / this.document.mainContractAttachments.length + '%';
            })
          }
        }, 100);
        this.viewDocumentsUpload();
      }
      this.isVisible = true;

      // hiển thị thông báo người dùng chọn vị trí
      this.checkSignManual();
    }
    // this.changeContent();
    // console.log(this.current)
  }

  resetValue() {
    this.errorStatus = null;
    this.signError = null;
    this.isCancel = false;
    this.isCallDone = false;
  }

  handlePreviewFromFileUpload(fileUpload: File) {
    this.commonService.getBase64(fileUpload)
      // tslint:disable-next-line:no-shadowed-variable
      .then((imageUrlPreviewBlod) => {
        this.imageUrlPreview = imageUrlPreviewBlod;
        this.selectedImageUrl = imageUrlPreviewBlod;
      });
  }

  handleSelectedCert() {
    if (this.selectedCert.typeCertificate === this.signMethod.SIGN_NO_CERT || this.typeSelectCertificate === this.signMethod.SIGN_NO_CERT) {
      this.isDisableNextButton = true;
    }
    if (this.selectedCert.imageUrl) {
      // @ts-ignore
      fetch(this.selectedCert.imageUrl)
        .then(r => r.blob())
        .then(blobFile => {
          this.fileUpload = new File([blobFile], 'fileNameGoesHere', {type: 'image/png'});
          this.selectedImage = this.fileUpload;
        });

      const img = new Image();
      img.src = this.selectedCert.imageUrl;
      img.onload = () => {
        // Get  width
        this.leftPosition = (this.widthRectangle - img.width * this.heightRectangle / img.height) / 2;
        // tslint:disable-next-line:max-line-length
        // contentNode = `<img src="${this.selectedCert.imageUrl}" style="height: 100%; position: relative; left: ${leftPosition}px;"/>`;
      };
    }
  }

  done(): void {
  }

  onSelectDrawSign() {
    // this.disableBtnDeleteCanvas = true;
    // this.commonService.configCanvas(this.canvas.nativeElement, this.cx, this.canvasWidth, this.canvasHeight);
    this.canvasService.setIsSelectSignDraw(true);
  }

  subscribeValue() {
    this.documentService.contractInfo.subscribe(contract => {
      if (!contract) {
        this.getDocument();
      } else {
        this.document = contract;
        this.serviceTypeData = this.documentService.serviceTypeSource.getValue();
        this.loadServiceType();
      }
    });
    this.documentService.contractFilesInfo.subscribe(info => {
      this.listPdfSrc = info;
    });

    this.subcribePreviewImageUrl = this.canvasService.canvasImageUrl.subscribe(url => {
      this.imageUrlPreview = url;
      const img = new Image();
      img.src = this.imageUrlPreview;
      img.onload = () => {
        // console.log(img.width);
        this.widthImageRender = img.width;
        this.heightImageRender = img.height;
      }
    });


    this.subcribePreviewImage = this.canvasService.canvasImage.subscribe(fileImage => {
      this.fileUpload = fileImage;
    });


    this.canvasService.isDisableBtnDeleteCanvas.subscribe(disable => {
      this.disableBtnDeleteCanvas = disable;
      if (disable && this.current === 1 && this.indexSelect === 2) {
        this.isDisableNextButton = disable;
      } else if (disable && this.current === 1 && this.indexSelect === 1 && (this.selectedCert.typeCertificate === this.signMethod.SIGN_NO_CERT || this.typeSelectCertificate === this.signMethod.SIGN_NO_CERT)) {
        this.isDisableNextButton = true;
      } else {
        this.isDisableNextButton = false;
      }
    });

    this.isSelectedCert.subscribe(value => {
      if (this.current === 0) {
        this.isDisableNextButton = !value;
      }
    });

    this.documentService.cancelFlow.subscribe(status => {
      if (status != null || status != undefined) {
        this.isCancelSign = status
      }
    })

    // lấy sign position
    const position = JSON.parse(localStorage.getItem('SignPosition'));
    this.signPosition = position;
    if (position && position.length > 0) {
      if (this.signPosition.length === 1 && this.signPosition[0].signType === this.signPositionTypes.DIGITAL) {
        this.onlyDigital = true;
      } else {
        this.onlyDigital = false;
      }
      this.isAllowSelectSignPosition = false;
      this.imageData = position.map((item) => {
        const image = {
          positionX: item.x,
          positionY: item.y,
          pageNumber: item.pageNumber,
          signType: item.signType,
          widthRectangle: item.width,
          heightRectangle: item.height,
          id: item.id,
          zoom: 1,
          fileId: item.fileId,
          signPositionId: item.id,
          contractSignId: undefined
        };

        // Trường hợp tài khoản không chứng thực, kí gửi lên contractSignId
        if (localStorage.getItem('entTypeAnonymus') == '2') image.contractSignId = item.id;

        return image;
      });
    } else {
      this.isAllowSelectSignPosition = true;
      this.signPosition = [];
    }

    this.canvasService.isVisibleModalDrawSignature.subscribe(value => {
      this.isVisibleModalDrawSignature = value;
      // console.log("isVisibleModalDrawSignature: ", this.isVisibleModalDrawSignature);
    });

    // this.notificationService.getErrorCode().subscribe(errorCode => {
    //   if (errorCode === ErrorCode.NoAccessToContracts) {
    //     if (this.dialogRef) {
    //       this.dialogRef.close();
    //     }
    //     if (this.dialog)
    //       this.dialog.closeAll();
    //     this.isCheckAccessToContract = false;
    //   } else {
    //     this.isCheckAccessToContract = true;
    //   }
    // });
  }

  setIsSelectedCert(value) {
    this.isSelectedCertSource.next(value);
  }

  getDocument() {
    this.anonymousSignService.anonymousGetDetail(this.hashKey, this.tenantId, this.contractIdAndContractEnterpriseIdEncode).subscribe(rs => {
      this.checkDisplayMessageError(rs.code);
      this.document = rs.data.contractDTO;
      this.isShowImage = this.document.signConfig ? JSON.parse(this.document.signConfig).showImage : true;
      if (rs.data.contractDTO.isSignDigitalCertificate) {
        this.isSignDigitalCertificate = true;
        this.canMoveAndResize = rs.data.contractDTO.signConfig ? JSON.parse(rs.data.contractDTO.signConfig).resize : false;
      } else {
        this.isSignDigitalCertificate = false;
      }
      this.scopeType = this.document.scopeType || 0;
      this.documentService.setContractInfo(rs.data.contractDTO);
      this.documentService.setServiceType(rs.data.serviceType);
      this.serviceTypeData = rs.data.serviceType;
      this.isOutOfSmsMoney = rs.data.isOutOfSmsMoney;
      this.loadServiceType();
      if (rs.data.contractSignEntityList) {
        this.documentService.setSignPosition(rs.data.contractSignEntityList);
      } else {
        this.documentService.setSignPosition(null);
      }
      if (!this.listPdfSrc) {
        for (const item of this.document.mainContractAttachments) {
          this.viewDocumentUpload(item.path, item.fileSize);
        }
      }

    });
  }

  dummyRequest = ({file, onSuccess, onError}) => {
    this.fileUpload = file;
    this.isDisableNextButton = false;
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  };

  viewDocumentUpload(pdfFilePath, size?) {
    const data = {
      hashKey: this.hashKey,
      tenantId: this.tenantId,
      pdfFilePath: pdfFilePath
    };
    if (!this.env.pdfViewFullDownload && size && size > 10485760) {
      const queryString = Object.entries(data)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
      // const res = await this.commonService.getViewPdfForDocumentByFilePath(data).toPromise();
      const pdfSrc = `${this.BASE_URL}?${queryString}`;
      this.listPdfSrc[pdfFilePath] = pdfSrc;
      this.document.mainContractAttachments.forEach(item => {
        if (item.path == pdfFilePath) {
          item.loading = false;
        }
      });
    } else {
      try {
        this.anonymousSignService.anonymousGetContractFileByHashKey(this.hashKey, this.tenantId, pdfFilePath, (err) => {
        }).subscribe(
          res => {
            this.showPdf(res, pdfFilePath);
          }
        );
      } catch (e) {
      }
    }

  }

  handleChange(info: { file: NzUploadFile }): void {
    // this.isFormChanging = true;
    switch (info.file.status) {
      case 'uploading':
        this.loading = true;
        break;
      case 'done':
        // Get this url from response in real world.
        // tslint:disable-next-line:no-non-null-assertion
        this.commonService.getBase64Avatar(info.file!.originFileObj!, (imgUrl: string) => {
          this.loading = false;
          // tslint:disable-next-line:radix
          const img = new Image();
          // Set the src attribute to your URL
          img.src = imgUrl;
          this.imagePreviewWidth = img.width;
          this.imagePreviewHeight = img.height;
          // When the image is loaded, read the available properties
          this.avatarUrl = imgUrl;
          this.imageUrlPreview = imgUrl;
        });
        break;
      case 'error':
        this.toastr.error('Network error');
        this.loading = false;
        break;
    }
  }

  getStampWrapper(positionX: number, positionY: number, widthBase: number, heightBase: number, signType: string, id: string, element: any,
                  basePageIndex: number) {
    const positionData = this.signPosition.find(e => e.id === id);
    const width = positionData.width;
    const height = positionData.height;
    const stampNode = document.createElement('div');
    stampNode.setAttribute('id', `sign-${id}`);
    // const digitalNode = this.signPosition.find( e => e.x === positionX && e.y === positionY && e.signType === SignPositionTypes.DIGITAL);
    // let digitalElement;
    // if (digitalNode) {
    //   digitalElement = document.getElementById(`sign-${digitalNode.id}`);
    // }
    // stampNode.innerHTML = this.genStampContent();
    let signatureWidth = width * this.zoomLevel / 100;
    const heightRectangle = height * this.zoomLevel / 100;

    const wrapperLeft = (positionX * this.zoomLevel) / 100;
    const wrapperTop = (positionY * this.zoomLevel) / 100;
    const widthHeightRatio = width / height;

    // positionX: 100 * wrapperLeft / zoomLevel;
    // positionY: 100 * wrapperTop / zoomLevel;
    let {top, left} = element.getBoundingClientRect();
    const elementId = element.id.replace('text-pdf-layer-', '');
    stampNode.style.position = 'absolute';
    stampNode.style.left = `${wrapperLeft}px`;
    stampNode.style.top = `${wrapperTop}px`;
    stampNode.style.width = `${signatureWidth}px`;
    stampNode.style.height = `${heightRectangle}px`;
    stampNode.style.background = 'rgb(0,0,0,0.2)';
    stampNode.style.zIndex = '1';
    stampNode.style.border = '1px solid #999999';
    stampNode.style.lineHeight = '1.9';
    stampNode.style.color = '#00f';
    stampNode.style.fontFamily = 'Roboto, sans-serif';
    stampNode.style.padding = `${10 * this.zoomLevel / 100}px`;
    stampNode.style.fontSize = `${16 * this.zoomLevel / 100}px`;
    if (this.fileUpload) {
      stampNode.style.display = 'flex';
      stampNode.style.alignItems = 'center';
      stampNode.style.justifyContent = 'center';
    }

    stampNode.innerHTML = this.genStampContentWidthHeight(width, height, signType, !!positionData.isNew);
    stampNode.className = 'box-sign';
    // element.appendChild(stampNode);
    // if (this.canMoveAndResize) {

    // move element
    let baseWrapperLeft;
    let baseWrapperTop;
    let signId;
    if (this.canMoveAndResize) {
      if (!positionData.isNew) {
        stampNode.style.cursor = 'move';
        stampNode.addEventListener('mousedown', (e) => {
          const targetSignId = e.target as Element;
          signId = targetSignId.id.replace('sign-', '');
          baseWrapperLeft = stampNode.offsetLeft;
          baseWrapperTop = stampNode.offsetTop;
          stampNode.innerHTML = `<div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: red; cursor: move;">
      <div id="notify_outside" style="position: absolute;top: -${35 * signZoom}px;left: ${(stampNode.offsetWidth / 2 - 150) * signZoom}px;color: red; width: ${300 * signZoom}px">${this.translateService.instant('messages.click_to_select_sign_position')}</div>
        ${this.genStampContentWidthHeight(stampNode.offsetWidth, stampNode.offsetHeight, signType, !!positionData.isNew)}
      </div>`;

          document.documentElement.addEventListener('mousemove', doMove);
          document.documentElement.addEventListener('wheel', (wheelEvent) => {
            // stampNode.style.left = `${(wheelEvent.clientX - signatureWidth / 2 - left)}px`;
            // stampNode.style.top = `${(wheelEvent.clientY - heightRectangle / 2 - top)}px`;
            const elBounding = element.getBoundingClientRect();
            left = elBounding.left;
            top = elBounding.top;

          });
          document.documentElement.addEventListener('mouseup', stopMove);
        });
      }
      const signZoom = this.zoomLevel / 100;
      let goPage;
      // Move element sign
      const doMove = (e) => {
        // console.log(e);
        goPage = document.getElementById(`text-pdf-layer-${this.pageIndex}`);
        if (this.pageIndex + '' !== elementId && goPage) {
          const elBounding = goPage.getBoundingClientRect();
          left = elBounding.left;
          top = elBounding.top;
          stampNode.remove();
          goPage.appendChild(stampNode);
        } else {
          const elBounding = element.getBoundingClientRect();
          left = elBounding.left;
          top = elBounding.top;
          stampNode.remove();
          goPage.appendChild(stampNode);
        }
        stampNode.style.left = (e.clientX - stampNode.offsetWidth / 2 - left) + 'px';
        stampNode.style.top = (e.clientY - stampNode.offsetHeight / 2 - top) + 'px';
        // if (digitalElement) {
        //   digitalElement.style.left = (e.clientX - stampNode.offsetWidth / 2 - left) + 'px';
        //   digitalElement.style.top = (e.clientY - stampNode.offsetHeight / 2 - top) + 'px';
        // }
      };

      // stop move and save position
      const stopMove = (e) => {
        e.stopPropagation();
        if (stampNode.offsetWidth / 2 + stampNode.offsetLeft < 0
          || stampNode.offsetHeight / 2 + stampNode.offsetTop < 0
        ) {
          stampNode.style.left = baseWrapperLeft + 'px';
          stampNode.style.top = baseWrapperTop + 'px';
          this.pageIndex = basePageIndex;
        } else {
          baseWrapperLeft = stampNode.offsetLeft;
          baseWrapperTop = stampNode.offsetTop;
        }
        stampNode.innerHTML = this.genStampContentWidthHeight(stampNode.offsetWidth, stampNode.offsetHeight, signType, !!positionData.isNew);
        this.signPosition = this.signPosition.map(position => {
          if ((position.id === id) && position.fileId === fileId) {
            position.x = stampNode.offsetLeft / signZoom;
            position.y = stampNode.offsetTop / signZoom;
            position.pageNumber = this.pageIndex;
            // position.positionX = stampNode.offsetLeft / signZoom;
            // position.positionY = stampNode.offsetTop / signZoom;
            // position.pageNumber = this.pageIndex.toString();
          }
          return position;
        });
        this.imageData = this.imageData.map(position => {
          if ((position.id === id) && position.fileId === fileId) {
            position.positionX = stampNode.offsetLeft / signZoom;
            position.positionY = stampNode.offsetTop / signZoom;
            position.pageIndex = this.pageIndex;
            position.pageNumber = this.pageIndex;
          }
          return position;
        });
        rerenderSign();
        document.documentElement.removeEventListener('mousemove', doMove);
        document.documentElement.removeEventListener('mouseup', stopMove);
      };
      const fileId = this.decodeId(this.document.mainContractAttachments[this.activeFile].id);
      const resizer = document.createElement('div');
      resizer.setAttribute('class', 'resize-div-bot-right');
      resizer.style.setProperty('--zoom', signZoom.toString());
      const rerenderSign = () => {
        stampNode.appendChild(resizer);
        resizer.style.removeProperty('--zoom');
        resizer.style.setProperty('--zoom', (signZoom).toString());
        return;
      };
      if (signType !== SignPositionTypes.DIGITAL && this.canMoveAndResize) {

        stampNode.appendChild(resizer);

        let startX, startY;
        let baseWidth;
        let baseHeight;
        resizer.addEventListener('mousedown', (e) => {
          e.stopPropagation();
          startX = e.clientX;
          startY = e.clientY;
          const targetSignId = e.target as Element;
          signId = targetSignId.parentElement.id.replace('sign-', '');
          baseWidth = stampNode.offsetWidth;
          baseHeight = stampNode.offsetHeight;
          document.documentElement.addEventListener('mousemove', doDrag);
          document.documentElement.addEventListener('mouseup', stopDrag);

        });


        const doDrag = (e) => {
          e.stopPropagation();
          const signatureHeight = positionData.height * this.zoomLevel / 100;
          signatureWidth = positionData.width * this.zoomLevel / 100;
          stampNode.style.width = (signatureWidth + e.clientX - startX) + 'px';
          stampNode.style.height = (signatureHeight + e.clientY - startY) + 'px';
          const widthHeightRatioDrag = stampNode.offsetWidth / stampNode.offsetHeight;
          if (widthHeightRatio !== widthHeightRatioDrag) {
            stampNode.style.height = (stampNode.offsetWidth / widthHeightRatio) + 'px';
            stampNode.style.width = (stampNode.offsetHeight * widthHeightRatio) + 'px';
          }
          stampNode.style.maxWidth = (element.offsetWidth - stampNode.offsetLeft) + 'px';
          stampNode.style.maxHeight = (element.offsetHeight - stampNode.offsetTop) + 'px';
          // if (digitalElement) {
          //   digitalElement.style.height = stampNode.style.height;
          //   digitalElement.style.width = stampNode.style.width;
          //   digitalElement.style.maxWidth = (element.offsetWidth - stampNode.offsetLeft) + 'px';
          //   digitalElement.style.maxHeight = (element.offsetHeight - stampNode.offsetTop) + 'px';
          // }
          stampNode.innerHTML = this.genStampContentWidthHeight(Number(stampNode.offsetWidth), Number(stampNode.offsetHeight), signType, !!positionData.isNew);

          rerenderSign();
        };

        const stopDrag = (e) => {
          e.stopPropagation();
          if (stampNode.offsetWidth / 2 + wrapperLeft < 0 || stampNode.offsetHeight / 2 + wrapperTop < 0) {
            // stampNode.style.width = baseWidth + 'px';
            // stampNode.style.height = baseHeight + 'px';
          } else {
            baseWidth = stampNode.offsetWidth;
            baseHeight = stampNode.offsetHeight;
          }
          stampNode.innerHTML = this.genStampContentWidthHeight(Number(stampNode.offsetWidth), Number(stampNode.offsetHeight), signType, !!positionData.isNew);
          this.signPosition = this.signPosition.map(position => {
            if ((position.id === id) && position.fileId === fileId) {
              position.width = stampNode.offsetWidth;
              position.height = stampNode.offsetHeight;
            }
            return position;
          });
          this.imageData = this.imageData.map(position => {
            if ((position.id === id) && position.fileId === fileId) {
              position.widthRectangle = stampNode.offsetWidth;
              position.heightRectangle = stampNode.offsetHeight;
            }
            return position;
          });
          rerenderSign();
          document.documentElement.removeEventListener('mousemove', doDrag);
          document.documentElement.removeEventListener('mouseup', stopDrag);
        };
      }
    }
    //    resize element
    return stampNode;
  }

  genStampContentWidthHeight(widthRect: number, heightRect: number, signType: string, canNotMove: boolean): string {
    let contentNode: string;
    if (this.fileUpload) {
      const padding = 10;
      const zoom = this.zoomLevel / 100;
      let widthRectangle = widthRect * zoom;
      let heightRectangle = heightRect * zoom;

      widthRectangle -= padding * zoom * 2;
      heightRectangle -= padding * zoom * 2;

      let height = widthRectangle;
      let width = heightRectangle;
      const ratio = this.imagePreviewWidth / this.imagePreviewHeight;
      if (this.imagePreviewWidth > this.imagePreviewHeight) {
        width = widthRectangle;
        height = width / ratio;
        if (height > heightRectangle) {
          height = heightRectangle;
          width = height * ratio;
        }
      } else {
        height = heightRectangle;
        width = height * ratio;
      }

      const heightPx = `${height}px`;
      const widthPx = `${width}px`;

      if (signType === SignPositionTypes.DIGITAL) {
        contentNode = `<div></div>`;
      } else {
        if (this.systemImageSign) {
          contentNode = `
          <i class="fa fa-undo" aria-hidden="true" style="display: ${this.canMoveAndResize && !canNotMove ? '' : 'none'};font-size: ${15 * zoom}px; position: absolute; top: 5px; right: 5px; cursor: move; height: unset; width: unset; color: red; z-index: 100;"></i>
          <img draggable="false" src="${this.imageUrlPreview}" style="transform: scale(${this.signConfig.signaturePosition.value === 'top' || this.signConfig.signaturePosition.value === 'bottom' ? (heightRectangle + 20) / this.heightImageRender : (widthRectangle + 20) / this.widthImageRender}); display: flex;
          justify-content:
          flex-end; align-items: flex-start; object-fit: cover;"/>
           `;
        } else {
          contentNode = `
          <i class="fa fa-undo" aria-hidden="true" style="display: ${this.canMoveAndResize && !canNotMove ? '' : 'none'};font-size: ${15 * zoom}px; position: absolute; top: 5px; right: 5px; cursor: move; height: unset; width: unset; color: red; z-index: 100;"></i>
                   <img draggable="false" src="${this.imageUrlPreview}" style="height: ${heightPx};width: ${widthPx}; max-width: ${this.signConfig.signaturePosition.value === 'left' || this.signConfig.signaturePosition.value === 'right' ? '1386px' : 'none'}; max-height: ${this.signConfig.signaturePosition.value === 'top' || this.signConfig.signaturePosition.value === 'bottom' ? '538px' : 'none'}; margin: auto; display: flex; justify-content: flex-end; align-items: flex-start;"/>
                    `;
        }
      }

    } else {
      const id = this.document.mainContractAttachments[this.activeFile].id;
      const fileId = this.decodeId(id);
      const signs = this.signPosition.filter(sign => {
        return sign.fileId === fileId;
      });
      if ((this.typeSelectCertificate === this.signMethod.SIGN_SIM_CA || this.typeSelectCertificate === this.signMethod.CLOUD_CA)
        && ((signs && signs.length > 0) || (signs && signs.length === 0))) {
        if (signType === SignPositionTypes.DIGITAL) {
          contentNode = `<div></div>`;
        } else {
          contentNode = `
            <div>
                    ${this.translateService.instant('enterprise_contract.image_signing.no_image.signed_by')} ${this.selectedCert.certificateName}
                    <br/>
                    ${this.translateService.instant('enterprise_contract.image_signing.no_image.signed_date')} ${this.dateNow}
                  </div>
            `;
        }
      } else if (this.typeSelectCertificate === this.signMethod.SIGN_NO_CERT && ((signs && signs.length > 0) || (signs && signs.length === 0))) {
        if (signType === SignPositionTypes.DIGITAL) {
          contentNode = `<div></div>`;
        } else {
          contentNode = `
            <div>
                  ${this.translateService.instant('enterprise_contract.image_signing.no_image.signed_by')} ${this.enterpriseName}
                  <br/>
                  ${this.translateService.instant('enterprise_contract.image_signing.no_image.signed_date')} ${this.dateNow}
                  ${this.isNotAttestedUser ? '' : '<br/>'}
                  ${this.isNotAttestedUser ? '' : this.translateService.instant('enterprise_contract.image_signing.no_image.verified_info')}
             </div>
          `;
        }
      } else if (this.typeSelectCertificate === this.signMethod.SIGN_OTP && ((signs && signs.length > 0) || (signs && signs.length === 0))) {
        if (signType === SignPositionTypes.DIGITAL) {
          contentNode = `<div></div>`;
        } else {
          contentNode = `
              <div>
                ${this.translateService.instant('enterprise_contract.image_signing.no_image.signed_by')} ${this.enterpriseName}
                <br/>
                ${this.translateService.instant('enterprise_contract.image_signing.no_image.signed_phone')} ${this.otpPhoneNumber}
                <br/>
                ${this.translateService.instant('enterprise_contract.image_signing.no_image.signed_date')} ${this.dateNow}
                ${this.isNotAttestedUser ? '' : '<br/>'}
                ${this.isNotAttestedUser ? '' : this.translateService.instant('enterprise_contract.image_signing.no_image.verified_info')}
              </div>
            `;
        }
      } else if ((signs && signs.length > 1) || (signs && signs.length === 0)) {
        if (signType === SignPositionTypes.DIGITAL) {
          contentNode = `<div></div>`;
        } else {
          contentNode = `<div>
                  ${this.translateService.instant('enterprise_contract.image_signing.no_image.signed_by')} ${this.selectedCert.issuedTo}
                  <br/>
                  ${this.translateService.instant('enterprise_contract.image_signing.no_image.signed_date')} ${this.dateNow}
                </div>`;
        }
      } else if (signs && signs.length === 1 && signs[0].signType === SignPositionTypes.DIGITAL) {
        contentNode = `<div></div>`;
      } else if (signs && signs.length === 1 && signs[0].signType !== SignPositionTypes.DIGITAL) {
        contentNode = `<div>
              ${this.translateService.instant('enterprise_contract.image_signing.no_image.signed_by')} ${this.selectedCert.issuedTo}
              <br/>
              ${this.translateService.instant('enterprise_contract.image_signing.no_image.signed_date')} ${this.dateNow}
            </div>`;
      }
    }
    return contentNode;
  }

  textLayerRendered(ele) {
    const element = ele.source.textLayerDiv;
    const pageIndex = ele.source.pageNumber;
    element.addEventListener('mouseenter', () => {
      this.pageIndex = pageIndex;
    });
    // lấy các chữ ở trang pageNumber
    let signPosition;
    const fileId = this.document.mainContractAttachments[this.activeFile].id;
    const id = this.decodeId(fileId);
    const imageId = this.commonService.generateUUID();
    if (this.signPosition && this.signPosition.length > 0) {
      signPosition = this.signPosition.filter((item) => {
        return item.pageNumber === pageIndex && id === item.fileId;
      });
    }

    if (signPosition && signPosition.length > 0 && !this.isSelectPosition) {
      for (const position of signPosition) {
        const x = position.x;
        const y = position.y;
        const _width = position.width;
        const _height = position.height;
        const signType = position.signType;
        const id = position.id;
        const htmlNode = this.getStampWrapper(x, y, _width, _height, signType, id, element, parseInt(position.page));
        const hasImage = this.signPosition.some(e => e.signType === SignPositionTypes.IMAGE);
        if (signType === SignPositionTypes.DIGITAL && hasImage) {
          console.log('not show digital');
        } else {
          element.appendChild(htmlNode);
        }
      }
      if (!this.isGotoSignpage) {
        const firstPosition = signPosition[0];
        const firstPage = firstPosition.pageNumber;
        this.signPage = firstPosition.pageNumber;
        this.gotoSignPageNumber(firstPage);
        this.isGotoSignpage = true;
      }
      const fileCustomerSign = this.signPosition.find(sign => sign.fileId === id && sign.isNew);
      this.isAllowSelectSignPosition = !!fileCustomerSign;
      this.isSelectPosition = false;
    }
    if (this.isAllowSelectSignPosition) {
      element.addEventListener('mouseleave', (mouseoverEvent) => {
        if (this.isSelectPosition) {
          const nodeOther = document.getElementById('show-frames-notification');
          if (nodeOther) {
            nodeOther.remove();
          }
        }
      });
      element.addEventListener('wheel', (wheelEvent) => {
        if (this.isSelectPosition) {
          const node = element.querySelector('#show-frames-notification');
          const nodeOther = document.getElementById('show-frames-notificationn');
          if (!node && nodeOther) {
            nodeOther.remove();
          }
          const boundingClient = element.getBoundingClientRect();
          const {top, left} = boundingClient;
          const signatureWidth = this.widthRectangle * this.zoomLevel / 100;
          const heightRectangle = this.heightRectangle * this.zoomLevel / 100;
          if (!node) {
            const stampNode = document.createElement('div');
            stampNode.innerHTML = this.genStampContent();
            this.stampWrapper = stampNode;
            stampNode.style.position = 'absolute';
            stampNode.setAttribute('id', 'show-frames-notification');
            stampNode.style.left = `${(wheelEvent.clientX - signatureWidth / 2 - left)}px`;
            stampNode.style.top = `${(wheelEvent.clientY - heightRectangle / 2 - top)}px`;
            stampNode.style.width = `${signatureWidth}px`;
            stampNode.style.height = `${heightRectangle}px`;
            stampNode.style.zIndex = '1';
            stampNode.style.background = 'rgb(0,0,0,0.2)';
            stampNode.style.border = '1px solid';
            stampNode.style.lineHeight = '1.9';
            stampNode.style.color = 'blue';
            stampNode.style.fontFamily = 'Roboto, sans-serif';
            stampNode.style.padding = `${10 * this.zoomLevel / 100}px`;
            if (this.fileUpload) {
              stampNode.style.display = 'flex';
              stampNode.style.alignItems = 'center';
              stampNode.style.justifyContent = 'center';
            }

            element.appendChild(stampNode);
          } else {
            node.style.left = `${(wheelEvent.clientX - signatureWidth / 2 - left)}px`;
            node.style.top = `${(wheelEvent.clientY - heightRectangle / 2 - top)}px`;
          }
        }
      });
      element.addEventListener('mousedown', (mousedownEvent) => {
        if (this.isSelectPosition) {
          this.isSelectPosition = false;
          // xoá dòng chọn vị trí
          const framesNotification = document.getElementById('show-frames-notification');
          if (framesNotification) {
            framesNotification.remove();
          }
          const offsetParent = element.offsetParent.dataset;
          const {pageNumber} = offsetParent;
          const boundingClient = element.getBoundingClientRect();
          const {top, left} = boundingClient;
          const signatureWidth = this.widthRectangle * this.zoomLevel / 100;
          const heightRectangle = this.heightRectangle * this.zoomLevel / 100;
          const signZoom = this.zoomLevel / 100;

          const widthHeightRatio = signatureWidth / heightRectangle;
          const wrapperLeft = mousedownEvent.clientX - signatureWidth / 2 - left;
          const wrapperTop = mousedownEvent.clientY - heightRectangle / 2 - top;
          this.stampWrapper.style.left = `${wrapperLeft}px`;
          this.stampWrapper.style.top = `${wrapperTop}px`;
          this.stampWrapper.style.width = `${signatureWidth}px`;
          this.stampWrapper.style.height = `${heightRectangle}px`;
          this.stampWrapper.style.background = 'rgb(0,0,0,0.2)';
          this.stampWrapper.style.zIndex = '1';
          this.stampWrapper.style.border = '1px solid #999999';
          this.stampWrapper.style.lineHeight = '1.9';
          this.stampWrapper.style.color = '#00f';
          this.stampWrapper.style.fontFamily = 'Roboto, sans-serif';
          this.stampWrapper.style.padding = `${10 * this.zoomLevel / 100}px`;
          if (this.fileUpload) {
            this.stampWrapper.style.display = 'flex';
            this.stampWrapper.style.alignItems = 'center';
            this.stampWrapper.style.justifyContent = 'center';
          }

          this.stampWrapper.innerHTML = this.genStampContent();
          // console.log(this.canMoveAndResize);
          if (this.canMoveAndResize) {
            const resizer = document.createElement('div');
            resizer.setAttribute('class', 'resize-div-bot-right');
            resizer.style.setProperty('--zoom', signZoom.toString());
            const rerenderSign = () => {
              this.stampWrapper.appendChild(resizer);
              resizer.style.removeProperty('--zoom');
              resizer.style.setProperty('--zoom', (signZoom).toString());
              return;
            };
            this.stampWrapper.appendChild(resizer);
            let startX, startY;
            let baseWidth;
            let baseHeight;
            resizer.addEventListener('mousedown', (e) => {
              e.stopPropagation();
              startX = e.clientX;
              startY = e.clientY;
              // const targetSignId = e.target as Element;
              // signId = targetSignId.parentElement.id.replace('sign-', '');
              baseWidth = this.stampWrapper.offsetWidth;
              baseHeight = this.stampWrapper.offsetHeight;
              document.documentElement.addEventListener('mousemove', doDrag);
              document.documentElement.addEventListener('mouseup', stopDrag);

            });
            const doDrag = (e) => {
              e.stopPropagation();
              const positionData = this.signPosition.find(sign => sign.id === imageId);
              const signatureH = positionData.width * this.zoomLevel / 100;
              const signatureW = positionData.width * this.zoomLevel / 100;
              this.stampWrapper.style.width = (signatureW + e.clientX - startX) + 'px';
              this.stampWrapper.style.height = (signatureH + e.clientY - startY) + 'px';
              const widthHeightRatioDrag = this.stampWrapper.offsetWidth / this.stampWrapper.offsetHeight;
              if (widthHeightRatio !== widthHeightRatioDrag) {
                this.stampWrapper.style.height = (this.stampWrapper.offsetWidth / widthHeightRatio) + 'px';
                this.stampWrapper.style.width = (this.stampWrapper.offsetHeight * widthHeightRatio) + 'px';
              }
              this.stampWrapper.style.maxWidth = (element.offsetWidth - this.stampWrapper.offsetLeft) + 'px';
              this.stampWrapper.style.maxHeight = (element.offsetHeight - this.stampWrapper.offsetTop) + 'px';
              this.stampWrapper.innerHTML =
                this.genStampContentWidthHeight(Number(this.stampWrapper.offsetWidth), Number(this.stampWrapper.offsetHeight), null, true);

              rerenderSign();
            };
            const stopDrag = (e) => {
              e.stopPropagation();
              if (this.stampWrapper.offsetWidth / 2 + wrapperLeft < 0 || this.stampWrapper.offsetHeight / 2 + wrapperTop < 0) {
                this.stampWrapper.style.width = baseWidth + 'px';
                this.stampWrapper.style.height = baseHeight + 'px';
              } else {
                baseWidth = this.stampWrapper.offsetWidth;
                baseHeight = this.stampWrapper.offsetHeight;
              }
              this.stampWrapper.innerHTML =
                this.genStampContentWidthHeight(Number(this.stampWrapper.offsetWidth), Number(this.stampWrapper.offsetHeight), null, true);
              // this.signPosition[0].width = this.stampWrapper.offsetWidth;
              // this.signPosition[0].height = this.stampWrapper.offsetHeight;
              // this.imageData[0].widthRectangle = this.stampWrapper.offsetWidth;
              // this.imageData[0].heightRectangle = this.stampWrapper.offsetHeight;
              this.signPosition = this.signPosition.map(position => {
                if ((position.id === imageId) && position.fileId === id) {
                  position.width = this.stampWrapper.offsetWidth;
                  position.height = this.stampWrapper.offsetHeight;
                }
                return position;
              });
              this.imageData = this.imageData.map(position => {
                if ((position.id === imageId) && position.fileId === id) {
                  position.widthRectangle = this.stampWrapper.offsetWidth;
                  position.heightRectangle = this.stampWrapper.offsetHeight;
                }
                return position;
              });
              rerenderSign();
              document.documentElement.removeEventListener('mousemove', doDrag);
              document.documentElement.removeEventListener('mouseup', stopDrag);
            };
          }

          element.appendChild(this.stampWrapper);

          // xoá dòng thông báo click để chọn vị trí
          document.querySelectorAll('#notify_outside').forEach(item => {
            if (item) {
              item.remove();
            }
          });
          const zoomLevel = this.zoomLevel;
          this.imageData = this.imageData.filter(img => {
            return img.fileId !== fileId;
          });
          this.imageData.push({
            stampPositionLeft: mousedownEvent.clientX - signatureWidth / 2 - left,
            stampPositionTop: mousedownEvent.clientY - heightRectangle / 2 - top,
            // positionX: 100 * (mousedownEvent.clientX - signatureWidth / 2 - left) / zoomLevel,
            positionX: 100 * wrapperLeft / zoomLevel,
            // positionY: 100 * (mousedownEvent.clientY - heightRectangle / 2 - top) / zoomLevel,
            positionY: 100 * wrapperTop / zoomLevel,
            pageIndex,
            zoom: this.zoomLevel / 100,
            pdfSrc: this.pdfSrc,
            id: imageId,
            isNew: true,
            pageNumber,
            signType: SignPositionTypes.COMBINE,
            type: SignDocumentComponent.SIGN_SINGLE,
            widthRectangle: this.widthRectangle,
            heightRectangle: this.heightRectangle,
            fileId: id
          });
          this.signPosition = this.signPosition.filter(sp => {
            return sp.fileId !== id;
          });
          this.signPosition.push({
            fileId: id,
            isNew: true,
            signType: SignPositionTypes.COMBINE,
            pageNumber: Number(pageIndex),
            x: 100 * wrapperLeft / zoomLevel,
            y: 100 * wrapperTop / zoomLevel,
            width: this.widthRectangle,
            height: this.heightRectangle,
            id: imageId
          });
          if (this.fileError.includes(fileId)) {
            this.fileError = this.fileError.filter(idFile => {
              return idFile !== fileId;
            });
          }
        }
      });
      element.addEventListener('mousemove', (mousemoveEvent) => {
        if (this.isSelectPosition) {
          // xoá dòng chọn vị trí
          const node = element.querySelector('#show-frames-notification');
          const nodeOther = document.getElementById('show-frames-notification');
          if (!node && nodeOther) {
            nodeOther.remove();
          }
          const boundingClient = element.getBoundingClientRect();
          const {top, left} = boundingClient;
          const signatureWidth = this.widthRectangle * this.zoomLevel / 100;
          const heightRectangle = this.heightRectangle * this.zoomLevel / 100;
          if (!node) {
            const stampNode = document.createElement('div');
            stampNode.innerHTML = this.genStampContent();
            stampNode.style.position = 'absolute';
            stampNode.setAttribute('id', 'show-frames-notification');
            stampNode.style.left = `${(mousemoveEvent.clientX - signatureWidth / 2 - left)}px`;
            stampNode.style.top = `${(mousemoveEvent.clientY - heightRectangle / 2 - top)}px`;
            stampNode.style.width = `${signatureWidth}px`;
            stampNode.style.height = `${heightRectangle}px`;
            stampNode.style.zIndex = '1';
            stampNode.style.background = 'rgb(0,0,0,0.2)';
            stampNode.style.border = '1px solid';
            stampNode.style.lineHeight = '1.9';
            stampNode.style.color = '#00f';
            stampNode.style.fontFamily = 'Roboto, sans-serif';
            stampNode.style.padding = `${10 * this.zoomLevel / 100}px`;
            if (this.fileUpload) {
              stampNode.style.display = 'flex';
              stampNode.style.alignItems = 'center';
              stampNode.style.justifyContent = 'center';
            }

            element.appendChild(stampNode);
          } else {
            node.style.left = `${(mousemoveEvent.clientX - signatureWidth / 2 - left)}px`;
            node.style.top = `${(mousemoveEvent.clientY - heightRectangle / 2 - top)}px`;
          }
        }
      });
    }
    element.style.opacity = '1';
    element.setAttribute('id', `text-pdf-layer-${pageIndex}`);
    this.pageIndex++;
  }

  // showPdf(blob: any) {
  //   const file = this.blobToFile(blob, 'application/pdf');
  //   this.commonService.readFile(file, (pdfSrc) => {
  //     this.pdfSrc = pdfSrc;
  //   });
  // }
  showPdf(blob: any, pdfFilePath: string) {
    const file = this.blobToFile(blob, 'application/pdf');
    this.commonService.readFile(file, (pdfSrc) => {
      this.pdfSrc = pdfSrc;
      if (!this.listPdfSrc) {
        this.listPdfSrc = {}
      }
      this.listPdfSrc[pdfFilePath] = pdfSrc;
      this.document.mainContractAttachments.forEach(item => {
        if (item.path == pdfFilePath) {
          item.loading = false;
        }
      });
      // this.isLoadAllPdfSrc = this.document.mainContractAttachments.filter(item=> {return item.loading}).length == 0;
    });
  }

  public blobToFile = (theBlob: Blob, fileName: string): File => {
    const b: any = theBlob;
    // A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;

    // Cast to a File() type
    return theBlob as File;
  };

  gotoSignPage() {
    const signPage = this.signPage || 1;
    this.pageCurrent = signPage;
    // const textLayer = document.getElementById(`text-pdf-layer-${Number(signPage)}`);
    // if (textLayer) {
    //   textLayer.scrollIntoView();
    // }
  }

  gotoSignPageNumber(signPage: number) {
    this.pageCurrent = signPage;
  }

  onStamped() {
    this.isSelectPosition = true;
    const id = this.document.mainContractAttachments[this.activeFile].id;
    const fileId = this.decodeId(id);
    if (fileId && this.signPosition && this.signPosition.length > 0) {
      this.signPosition = this.signPosition.filter(sign => {
        return sign.fileId !== fileId;
      });
    }
    if (fileId && this.imageData && this.imageData.length > 0) {
      this.imageData = this.imageData.filter(image => {
        return image.fileId !== fileId;
      });
    }
    const listElement = document.getElementsByClassName('box-sign');
    if (listElement && listElement.length) {
      listElement.item(0).remove();
    }
    const nodeOther = document.getElementById('show-frames-notification');
    if (nodeOther) {
      nodeOther.remove();
    }
    if (this.current > 0) {
      this.showFramesNotification();
    }
  }

  showFramesNotification() {
    const nodeOther = document.getElementById('show-frames-notification');
    if (nodeOther) {
      nodeOther.remove();
    }
    const navBoundingClient = this.navigation.nativeElement.getBoundingClientRect();
    const {top, left, bottom, width, height} = navBoundingClient;
    const signatureWidth = this.widthRectangle * this.zoomLevel;
    const heightRectangle = this.heightRectangle * this.zoomLevel;
    const navigation = document.getElementById('navigation');
    const newTop = top - 2 * heightRectangle;
    const newLeft = width / 2 - signatureWidth / 2;
    const stampNode = document.createElement('div');
    stampNode.setAttribute('id', 'show-frames-notification');
    const contentNode = `<span style="color: red;">${this.translateService.instant('messages.click_to_select_sign_position')}</span>`;
    stampNode.style.position = 'absolute';
    stampNode.style.background = 'rgb(0,0,0,0.2)';
    stampNode.innerHTML = contentNode;
    stampNode.style.left = `${newLeft}px`;
    stampNode.style.top = `${newTop}px`;
    stampNode.style.width = `${signatureWidth}px`;
    stampNode.style.height = `${heightRectangle}px`;
    stampNode.style.zIndex = '1';
    stampNode.style.border = '1px solid #999999';
    if (this.fileUpload) {
      stampNode.style.display = 'flex';
      stampNode.style.alignItems = 'center';
      stampNode.style.justifyContent = 'center';
    }

    this.stampWrapper = stampNode;
    navigation.appendChild(stampNode);
  }

  pageRendered(e) {
    // this.thumbnail.push({
    //   page: e.pageNumber,
    //   url: e.source.canvas.toDataURL()
    // });
  }

  gotoPage(page: number) {
    const textLayer = document.getElementById(`text-pdf-layer-${page - 1}`);
    if (textLayer) {
      textLayer.scrollIntoView();
    }
  }

  async processSignNoCertificate() {
    let isSuccess = true;
    const filePath = {};
    const mainContractAttachmentsNew = [];
    for await (const img of this.signProcessing) {
      if (this.isCancel) {
        isSuccess = false;
        break;
      }
      const sign = JSON.parse(JSON.stringify(this.sign));
      sign.position = JSON.stringify(img);
      const file = this.document.mainContractAttachments.find(ca => this.decodeId(ca.id) === img.fileId);
      sign.path = file && file.path ? file.path : null;
      sign.oldPath = filePath[img.fileId] ? filePath[img.fileId] : '';
      sign.image = this.fileUpload;

      let res;

      if (this.indexSelect === 0 && this.fileUpload) {
        const newDate = await this.signDocumentService.getDateAsync().toPromise();
        if (!newDate || !newDate.data || !newDate.data.date) {
          return;
        }

        this.signConfig.signingTime.value = newDate.data.date;

        this.cd.detectChanges();
        let blob = null;
        try {
          let imageSize = this.setSizeFrameImage();
          blob = await this.imageGenerateService.genImage(this.signConfig, imageSize).toPromise();
        } catch (e) {
          console.log("call api error, use html to image", e);
          try {
            let imageSize = this.setSizeFrameImage();
            blob = await this.imageGenerateService.genImage(this.signConfig, imageSize).toPromise();
          } catch (e) {
            console.log("call api error, use html to image", e);
          }
        }
        if(!blob){
          this.toastr.error(this.message.getMessage('messages.error_proccessing'));
          isSuccess = false;
          break;
        }

        const newFile = new File([blob], 'lastImage.png', {type: 'image/png'});
        this.fileUpload = newFile;

        sign.image = this.fileUpload;

        res = await this.anonymousSignService.signWithImageNoCertificateBase64(sign);

        if (res && !res.success) {
          isSuccess = false;
          this.signError = res && res.message ? res.message : null;
          break;
        } else if (!res || !res.data) {
          isSuccess = false;
          break;
        } else {
          filePath[img.fileId] = res.data.path;
          const contractAttachment = mainContractAttachmentsNew.find(ca => ca.id === file.id);
          if (!contractAttachment) {
            const contractAttachmentNew = JSON.parse(JSON.stringify(file));
            contractAttachmentNew.path = res.data.path;
            mainContractAttachmentsNew.push(contractAttachmentNew);
          } else {
            contractAttachment.path = res.data.path;
          }
          if (!this.isCancel) {
            img.done = true;
          }
        }
      } else {
        res = await this.anonymousSignService.signWithImageNoCertificateBase64(sign);
        if (res && !res.success) {
          isSuccess = false;
          this.signError = res && res.message ? res.message : null;
          break;
        }
        if (!res || !res.data) {
          isSuccess = false;
          break;
        } else {
          filePath[img.fileId] = res.data.path;
          const contractAttachment = mainContractAttachmentsNew.find(ca => ca.id === file.id);
          if (!contractAttachment) {
            const contractAttachmentNew = JSON.parse(JSON.stringify(file));
            contractAttachmentNew.path = res.data.path;
            mainContractAttachmentsNew.push(contractAttachmentNew);
          } else {
            contractAttachment.path = res.data.path;
          }
          if (!this.isCancel) {
            img.done = true;
          }
        }
      }
    }
    if (this.isCancel) {
      isSuccess = false;
    }
    const data = {
      signMethod: this.typeSelectCertificate,
      contractId: this.document.id,
      mainContractAttachments: mainContractAttachmentsNew,
      certificate: this.sign.certificate,
      hashKey: this.hashKey,
      tenantId: this.tenantId,
      signTransactionId: this.signTransactionId,
      userCancel: this.userCancel,
      message: this.messageSign
    };
    if (isSuccess) {
      this.isCallDone = true;
      const res = await this.anonymousSignService.signDone(data).toPromise();
      if (res && res.data) {
        this.onSignSuccess();
      } else {
        this.isCallDone = false;
      }
    } else {
      this.anonymousSignService.signCancel(data, this.contractIdAndContractEnterpriseIdEncode).subscribe(rs => {
        this.checkDisplayMessageError(rs.code);
        this.errorStatus = "messages.stop_sign_document";
      });
    }
  }

  async processSignSimCAImage() {
    const id = this.commonService.generateUUID();
    this.processingId = id;
    const sign = JSON.parse(JSON.stringify(this.sign));
    sign.signTransactionCode = this.commonService.generateUUID();
    sign.signPositions = JSON.stringify(this.signProcessing);
    sign.image = this.fileUpload;
    sign.message = this.messageSign;

    this.getApiSignImageSystem(this.anonymousSignService.anonymousSignSimCaImageBase64, sign, this.contractIdAndContractEnterpriseIdEncode)
    // this.anonymousSignService.anonymousSignSimCaImage(sign,this.contractIdAndContractEnterpriseIdEncode).subscribe(res => {
    //   this.checkDisplayMessageError(res.code);
    //  })
    this.signingProcess(sign.signTransactionCode)
    // let isSuccess = true;
    // const filePath = {};
    // const mainContractAttachmentsNew = [];
    // for await (const img of this.signProcessing) {
    //   if (this.isCancel) {
    //     isSuccess = false;
    //     break;
    //   }
    //   const sign = JSON.parse(JSON.stringify(this.sign));
    //   sign.position = JSON.stringify(img);
    //   const file = this.document.mainContractAttachments.find(ca => this.decodeId(ca.id) === img.fileId);
    //   sign.path = file && file.path ? file.path : null;
    //   sign.oldPath = filePath[img.fileId] ? filePath[img.fileId] : '';
    //   sign.image = this.fileUpload;
    //   const res = await this.anonymousSignService.anonymousSignSimCaImage(sign).toPromise();
    //   if (res && !res.success) {
    //     isSuccess = false;
    //     if (!this.isCancelSign) {
    //       this.signError = res && res.message ? res.message : null;
    //     }
    //     break;
    //   }
    //   if (!res || !res.data) {
    //     isSuccess = false;
    //     break;
    //   } else {
    //     filePath[img.fileId] = res.data.path;
    //     const contractAttachment = mainContractAttachmentsNew.find(ca => ca.id === file.id);
    //     if (!contractAttachment) {
    //       const contractAttachmentNew = JSON.parse(JSON.stringify(file));
    //       contractAttachmentNew.path = res.data.path;
    //       mainContractAttachmentsNew.push(contractAttachmentNew);
    //     } else {
    //       contractAttachment.path = res.data.path;
    //     }
    //     if (!this.isCancel) {
    //       img.done = true;
    //     }
    //   }
    // }
    // if (this.isCancel) {
    //   isSuccess = false;
    // }
    // const data = {
    //   signMethod: this.typeSelectCertificate,
    //   contractId: this.document.id,
    //   mainContractAttachments: mainContractAttachmentsNew,
    //   certificate: this.sign.certificate,
    //   hashKey: this.hashKey,
    //   tenantId: this.tenantId,
    //   phoneNumber: this.simCaPhoneNumber,
    //   serialNumber: this.selectedCert.serialNumber,
    //   signTransactionId: this.signTransactionId,
    //   userCancel: this.userCancel,
    // };

    // if (isSuccess) {
    //   this.isCallDone = true;
    //   const res = await this.anonymousSignService.signDone(data).toPromise();
    //   if (res && res.data) {
    //     this.onSignSuccess();
    //   } else {
    //     this.isCallDone = false;
    //   }
    // } else {
    //   this.anonymousSignService.signCancel(data).subscribe(rs => {
    //     this.errorStatus = "messages.stop_sign_document";
    //   });
    // }
  }

  async processSignCloudCA() {
    let isSuccess = true;
    const filePath = {};
    const mainContractAttachmentsNew = [];
    const _data = [];
    const hashMap = {};
    let id = 0;
    const processingId = this.commonService.generateUUID();
    this.processingId = processingId;
    let signPositions: any[] = []
    for (const item of this.signProcessing) {
      const fileId = item.fileId;
      if (fileId in hashMap) {
        hashMap[fileId].push({
          ...item
        })
      } else {
        hashMap[fileId] = [{
          ...item
        }]
      }
    }

    for (const key in hashMap) {
      _data.push({
        fileId: Number(key),
        listSignPosition: hashMap[key],
        ...this.sign
      })
    }
    // tìm số chữ ký nhiều nhất
    let maxSignPosition = 0;
    for (const item of _data) {
      if (item.listSignPosition.length > maxSignPosition) {
        maxSignPosition = item.listSignPosition.length
      }
    }
    // số vòng lặp bằng số position lớn nhất
    for (let i = 0; i < maxSignPosition; i++) {
      // lặp số lần bằng số file
      let request = [];
      for (const dataItem of _data) {
        if (dataItem.listSignPosition[i]) {
          const position = dataItem.listSignPosition[i];
          // listFileSign.push({
          //   ...dataItem,
          //   listSignPosition: null,
          //   ...position
          // })

          let requestItem = {
            ...this.sign,
            fileId: dataItem.fileId,
            position: position,
            image: null,
          };
          const file = this.document.mainContractAttachments.find(ca => this.decodeId(ca.id) === dataItem.fileId);
          requestItem.path = file && file.path ? file.path : null;
          requestItem.oldPath = filePath[requestItem.fileId] ? filePath[requestItem.fileId] : '';
          // if (this.fileUpload) {
          //   requestItem.image = this.fileUpload;
          // }
          signPositions.push(requestItem);
        }
      }
    }
    const newRequest = {
      ...this.sign,
      providerName: this.providerName,
      credentialId: this.sign.credentialId,
      cloudCaUserId: this.cloudCaUsername,
      listSignPosition: signPositions,
      signTransactionCode: this.commonService.generateUUID(),
      message: this.messageSign
    };
    if (this.fileUpload) {
      const imageRequest = {
        ...this.sign,
        providerName: this.providerName,
        credentialId: this.sign.credentialId,
        cloudCaUserId: this.cloudCaUsername,
        image: this.fileUpload,
        signTransactionCode: this.commonService.generateUUID(),
        listSignPosition: JSON.stringify(signPositions),
        message: this.messageSign
      };

      this.getApiSignImageSystem(this.anonymousSignService.signCloudCaImageBase64, imageRequest, this.contractIdAndContractEnterpriseIdEncode);
      this.signingProcess(imageRequest.signTransactionCode)
    } else {
      this.anonymousSignService.signCloudCaNoImage(newRequest, this.contractIdAndContractEnterpriseIdEncode).subscribe(res => {
        this.checkDisplayMessageError(res.code);
      })
      this.signingProcess(newRequest.signTransactionCode)
    }
    //   const newRequest = {
    //     ...this.sign,
    //     listSignPosition: request,
    //     providerName: this.providerName,
    //     cloudCaUserId: this.selectedCert.cloudCaUserId
    //   };
    //   let res = undefined;
    //   if (this.fileUpload) {
    //     const imageRequest = {
    //       ...newRequest,
    //       image: this.fileUpload,
    //       listSignPosition: JSON.stringify(newRequest.listSignPosition)
    //     };
    //     res = await this.anonymousSignService.signCloudCaImage(imageRequest).toPromise();
    //   } else {
    //     // sign.position = img;
    //     res = await this.anonymousSignService.signCloudCaNoImage(newRequest).toPromise();
    //   }

    //   if (this.processingId != processingId) {
    //     return;
    //   }

    //   if (res && !res.success) {
    //     isSuccess = false;
    //     if (!this.isCancelSign) {
    //       this.signError = res && res.message ? res.message : null;
    //     }
    //     break;
    //   }

    //   if (!res || !res.data) {
    //     isSuccess = false;
    //     break;
    //   } else {
    //     // update lại đường dẫn của mainContractAttachments tương ứng
    //     for (const item of res.data) {
    //       const file = this.document.mainContractAttachments.find(ca => this.decodeId(ca.id) == item.fileId);
    //       filePath[item.fileId] = item.path;
    //       const contractAttachment = mainContractAttachmentsNew.find(ca => ca.id == file.id);
    //       if (!contractAttachment) {
    //         const contractAttachmentNew = JSON.parse(JSON.stringify(file));
    //         contractAttachmentNew.path = item.path;
    //         mainContractAttachmentsNew.push(contractAttachmentNew);
    //       } else {
    //         contractAttachment.path = item.path;
    //       }

    //     }
    //     if (!this.isCancel) {
    //       for (const it of newRequest.listSignPosition) {
    //         for (let j = 0; j < this.signProcessing.length; j++) {
    //           if (this.signProcessing[j].index == it.signProcessingId) {
    //             this.signProcessing[j].done = true;
    //           }
    //         }
    //       }
    //       // item.done = true;
    //     }
    //   }
    // }
    // if (this.isCancel) {
    //   isSuccess = false;
    // }
    // const data = {
    //   hashKey: this.hashKey,
    //   tenantId: this.tenantId,
    //   signMethod: this.typeCertificate,
    //   contractId: this.document.id,
    //   mainContractAttachments: mainContractAttachmentsNew,
    //   certificate: this.sign.certificate,
    //   digitalCertificateDetailId: this.selectedCert.idDetail,
    //   phoneNumber: this.selectedCert.phoneNumber,
    //   serialNumber: this.selectedCert.serialNumber,
    //   providerName: this.providerName,
    //   credentialId: this.sign.credentialId,
    //   cloudCaUserId: this.cloudCaUsername,
    //   signTransactionId: this.signTransactionId,
    //   userCancel: this.userCancel,
    // };
    // if (isSuccess) {
    //   this.isCallDone = true;
    //   const res = await this.anonymousSignService.signDone(data).toPromise();
    //   if (res && res.data) {
    //     this.onSignSuccess();
    //   } else {
    //     this.isCallDone = false;
    //   }
    // } else {
    //   this.anonymousSignService.signCancel(data).subscribe(res => {
    //     this.errorStatus = "messages.stop_sign_document";
    //   });
    // }
  }

  showModalDrawSignature(): void {
    this.isVisibleModalDrawSignature = true;
  }

  handlerNextStep() {
    if (this.isDisableNextButton && (this.imageUrlPreview === null || this.imageUrlPreview === '')) {
      this.toastr.error(this.message.getMessage('validation.draw_sign_valid_empty'));
      return;
    }
    this.next();
  }

  handleOk(): void {

    if (this.disableBtnDeleteCanvas) {
      this.toastr.error(this.message.getMessage('validation.draw_sign_valid_empty'));
      return;
    }
    this.isVisibleModalDrawSignature = false;

    // sau khi vẽ ảnh thì lưu lại lên onSaveCanvas
    if (this.isSelectDrawImage) {
      this.canvasComponent.onSaveCanvas();
    }

    // hiển thị thông báo người dùng chọn vị trí
    if (this.isAllowSelectSignPosition) {
      this.onStamped();
    }

    // console.log("imageUrlPreview: ", this.imageUrlPreview);
    if (this.imageUrlPreview !== null && this.imageUrlPreview !== '' && this.imageUrlPreview !== undefined) {
      this.isDisableNextButton = false;
    } else {
      this.isDisableNextButton = true;
    }
  }

  handleCancel(): void {
    this.isVisibleModalDrawSignature = false;
    // console.log("imageUrlPreview: ", this.imageUrlPreview);
    if (this.imageUrlPreview !== null && this.imageUrlPreview !== '' && this.imageUrlPreview !== undefined) {
      this.isDisableNextButton = false;
    } else {
      this.isDisableNextButton = true;
    }
  }

  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  async processSignSimCANoImage() {
    const id = this.commonService.generateUUID();
    this.processingId = id;
    const sign = JSON.parse(JSON.stringify(this.sign));
    sign.signTransactionCode = this.commonService.generateUUID();
    sign.signPositions = JSON.stringify(this.signProcessing);
    sign.message = this.messageSign;
    this.anonymousSignService.anonymousSignSimCaNoImage(sign, this.contractIdAndContractEnterpriseIdEncode).subscribe(res => {
      this.checkDisplayMessageError(res.code);
    })
    this.signingProcess(sign.signTransactionCode)
    // let isSuccess = true;
    // const filePath = {};
    // const mainContractAttachmentsNew = [];
    // for await (const img of this.signProcessing) {
    //   if (this.isCancel) {
    //     isSuccess = false;
    //     break;
    //   }
    //   const sign = JSON.parse(JSON.stringify(this.sign));
    //   sign.position = JSON.stringify(img);
    //   const file = this.document.mainContractAttachments.find(ca => this.decodeId(ca.id) === img.fileId);
    //   sign.path = file && file.path ? file.path : null;
    //   sign.oldPath = filePath[img.fileId] ? filePath[img.fileId] : '';
    //   const res = await this.anonymousSignService.anonymousSignSimCaNoImage(sign).toPromise();
    //   if (res && !res.success) {
    //     isSuccess = false;
    //     if (!this.isCancelSign) {
    //       this.signError = res && res.message ? res.message : null;
    //     }
    //     break;
    //   }
    //   if (!res || !res.data) {
    //     isSuccess = false;
    //     break;
    //   } else {
    //     filePath[img.fileId] = res.data.path;
    //     const contractAttachment = mainContractAttachmentsNew.find(ca => ca.id === file.id);
    //     if (!contractAttachment) {
    //       const contractAttachmentNew = JSON.parse(JSON.stringify(file));
    //       contractAttachmentNew.path = res.data.path;
    //       mainContractAttachmentsNew.push(contractAttachmentNew);
    //     } else {
    //       contractAttachment.path = res.data.path;
    //     }
    //     if (!this.isCancel) {
    //       img.done = true;
    //     }
    //   }
    // }
    // if (this.isCancel) {
    //   isSuccess = false;
    // }
    // const data = {
    //   signMethod: this.typeSelectCertificate,
    //   contractId: this.document.id,
    //   mainContractAttachments: mainContractAttachmentsNew,
    //   certificate: this.sign.certificate,
    //   hashKey: this.hashKey,
    //   tenantId: this.tenantId,
    //   phoneNumber: this.simCaPhoneNumber,
    //   serialNumber: this.selectedCert.serialNumber,
    //   signTransactionId: this.signTransactionId,
    //   userCancel: this.userCancel,
    // };
    // if (isSuccess) {
    //   this.isCallDone = true;
    //   const res = await this.anonymousSignService.signDone(data).toPromise();
    //   if (res && res.data) {
    //     this.onSignSuccess();
    //   } else {
    //     this.isCallDone = false;
    //   }
    // } else {
    //   this.anonymousSignService.signCancel(data).subscribe(rs => {
    //     this.errorStatus = "messages.stop_sign_document";
    //   });
    // }
  }

  onClickConfirmButtonNoImage() {
    switch (this.typeSelectCertificate) {
      case this.signMethod.SIGN_USB_TOKEN:
        //this.blockUI.start('');
        //initPluginCertificateNormal(this);
        this.createHash(this.usbTokenCertificate.certRawdata);
        break;
      case this.signMethod.SIGN_SIM_CA:
        this.isCallDone = false;
        this.processSignSimCANoImage();
        break;
      case this.signMethod.SIGN_NO_CERT:
        this.processSignNoCertificate();
        break;
      // case this.signMethod.SIGN_OTP:
      //   if (this.isShowEKYC && this.current === 2) {
      //     this.onNextEKYC()
      //   } else {
      //     this.processSignOTP()
      //   }
      //   break;
      case this.signMethod.CLOUD_CA:
        this.processSignCloudCA();
        break;
      default:
        break;
    }
  }

  onClickConfirmButtonImage() {
    switch (this.typeSelectCertificate) {
      case this.signMethod.SIGN_USB_TOKEN:
        //this.blockUI.start('');
        // initPluginCertificateNormal(this);
        this.createHash(this.usbTokenCertificate.certRawdata);
        break;
      case this.signMethod.SIGN_SIM_CA:
        this.isCallDone = false;
        this.processSignSimCAImage();
        break;
      case this.signMethod.SIGN_NO_CERT:
        this.processSignNoCertificate();
        break;
      // case this.signMethod.SIGN_OTP:
      //   if (this.isShowEKYC && this.current === 2) {
      //     this.onNextEKYC()
      //   } else {
      //     this.processSignOTP()
      //   }
      //   break;
      case this.signMethod.CLOUD_CA:
        this.processSignCloudCA();
        break;
      default:
        break;
    }
  }

  async createHashSvc(certUserBase64: string) {
    this.sign.certificate = certUserBase64;
    if (this.fileUpload) {
      const filePath = {};
      let isSuccess = true;
      const mainContractAttachmentsNew = [];
      for await (const [index, img] of this.signProcessing.entries()) {
        if (this.isCancel) {
          isSuccess = false;
          break;
        }
        const sign = JSON.parse(JSON.stringify(this.sign));
        sign.image = this.fileUpload;
        sign.position = JSON.stringify(img);
        const file = this.document.mainContractAttachments.find(ca => this.decodeId(ca.id) === img.fileId);
        sign.path = file && file.path ? file.path : null;
        sign.oldPath = filePath[img.fileId] ? filePath[img.fileId] : '';

        let rs;
        if (this.indexSelect === 0 && this.fileUpload) {
          const newDate = await this.signDocumentService.getDateAsync().toPromise();
          if (!newDate || !newDate.data || !newDate.data.date) {
            return;
          }

          this.signConfig.signingTime.value = newDate.data.date;

          this.cd.detectChanges();
          let blob = null;
          try {
            let imageSize = this.setSizeFrameImage();
            blob = await this.imageGenerateService.genImage(this.signConfig, imageSize).toPromise();
          } catch (e) {
            console.log("call api error, use html to image", e);
            try {
              let imageSize = this.setSizeFrameImage();
              blob = await this.imageGenerateService.genImage(this.signConfig, imageSize).toPromise();
            } catch (e) {
              console.log("call api error, use html to image", e);
            }
          }

          if(!blob){
            this.toastr.error(this.message.getMessage('messages.error_proccessing'));
            isSuccess = false;
            break;
          }

          const newFile = new File([blob], 'lastImage.png', {type: 'image/png'});
          this.fileUpload = newFile;

          sign.image = this.fileUpload;

          rs = await this.anonymousSignService.createHashWithImageBase64(sign, this.contractIdAndContractEnterpriseIdEncode);

          if (this.contractIdAndContractEnterpriseIdEncode) {
            this.checkExpireTime();
          }

          if (rs && !rs.success) {
            isSuccess = false;
            this.signError = rs && rs.message ? rs.message : null;
          } else if (rs && rs.data) {
            sign.path = rs.data.path;
            sign.signPdf = rs.data.signPdf;
            filePath[img.fileId] = rs.data.path;
            const contractAttachment = mainContractAttachmentsNew.find(ca => ca.id === file.id);
            if (!contractAttachment) {
              const contractAttachmentNew = JSON.parse(JSON.stringify(file));
              contractAttachmentNew.path = rs.data.path;
              mainContractAttachmentsNew.push(contractAttachmentNew);
            } else {
              contractAttachment.path = rs.data.path;
            }
            const signature = await anonymousSignHashAsyncNew(this, rs.data.hash, this.sessionId, this.usbTokenCertificate.serialNumber);
            if (!signature) {
              this.errorStatus = 'messages.error_not_find_certificate';
              isSuccess = false;
              break;
            }
            if (index === 0) {
              this.isCallDone = false;
            }
            sign.signature = signature;
            sign.position = JSON.parse(sign.position);
            sign.signPositions = this.signImages;
            sign.image = this.commonService.convertEmptyObjectToNull(sign.image);
            const resSign = await this.signUsb(sign, this.contractIdAndContractEnterpriseIdEncode);
            if (this.contractIdAndContractEnterpriseIdEncode) {
              this.checkExpireTime();
            }
            if (resSign && !resSign.success) {
              this.signError = resSign && resSign.message ? resSign.message : null;
              isSuccess = false;
              break;
            }
            if (!resSign || !resSign.data) {
              isSuccess = false;
              break;
            }
            if (!this.isCancel) {
              img.done = true;
            }
          } else {
            isSuccess = false;
            break;
          }
        } else {
          rs = await this.anonymousSignService.createHashWithImageBase64(sign, this.contractIdAndContractEnterpriseIdEncode);
          if (this.contractIdAndContractEnterpriseIdEncode) {
            this.checkExpireTime();
          }

          if (rs && !rs.success) {
            isSuccess = false;
            this.signError = rs && rs.message ? rs.message : null;
            break;
          }
          if (rs && rs.data) {
            sign.path = rs.data.path;
            sign.signPdf = rs.data.signPdf;
            filePath[img.fileId] = rs.data.path;
            const contractAttachment = mainContractAttachmentsNew.find(ca => ca.id === file.id);
            if (!contractAttachment) {
              const contractAttachmentNew = JSON.parse(JSON.stringify(file));
              contractAttachmentNew.path = rs.data.path;
              mainContractAttachmentsNew.push(contractAttachmentNew);
            } else {
              contractAttachment.path = rs.data.path;
            }
            const signature = await anonymousSignHashAsyncNew(this, rs.data.hash, this.sessionId, this.usbTokenCertificate.serialNumber);
            if (!signature) {
              this.errorStatus = 'messages.error_not_find_certificate';
              isSuccess = false;
              break;
            }
            if (index === 0) {
              this.isCallDone = false;
            }
            sign.signature = signature;
            sign.position = JSON.parse(sign.position);
            sign.signPositions = this.signImages;
            sign.image = this.commonService.convertEmptyObjectToNull(sign.image);
            const resSign = await this.signUsb(sign, this.contractIdAndContractEnterpriseIdEncode);
            if (this.contractIdAndContractEnterpriseIdEncode) {
              this.checkExpireTime();
            }
            if (resSign && !resSign.success) {
              this.signError = resSign && resSign.message ? resSign.message : null;
              isSuccess = false;
              break;
            }
            if (!resSign || !resSign.data) {
              isSuccess = false;
              break;
            }
            if (!this.isCancel) {
              img.done = true;
            }
          } else {
            isSuccess = false;
            break;
          }
        }
      }
      if (this.isCancel) {
        isSuccess = false;
      }
      const data = {
        signMethod: this.typeSelectCertificate,
        contractId: this.document.id,
        mainContractAttachments: mainContractAttachmentsNew,
        certificate: this.sign.certificate,
        hashKey: this.hashKey,
        tenantId: this.tenantId,
        signTransactionId: this.signTransactionId,
        userCancel: this.userCancel,
        message: this.messageSign
      };
      if (isSuccess) {
        this.isCallDone = true;
        const res = await this.anonymousSignService.signDone(data).toPromise();
        if (res && res.data) {
          this.onSignSuccess();
        } else {
          this.isCallDone = false;
        }
      } else {
        this.anonymousSignService.signCancel(data, this.contractIdAndContractEnterpriseIdEncode).subscribe(rs => {
          this.errorStatus = "messages.stop_sign_document";
        });
      }
      // this.anonymousSignService.createHashWithImage(this.sign).subscribe(rs => {
      //   this.sign.path = rs.data.path;
      //   this.sign.signPdf = rs.data.signPdf;
      //   // this.sign.signature = signHash(this, rs.data.hash);
      //   // this.sign.signature = anonymousSignHash(this, rs.data.hash, this.sessionId, this.usbTokenCertificate.serialNumber);
      //   // this.signUsb(this.sign);
      //   anonymousSignHashAsyncNew(this, rs.data.hash, this.sessionId, this.usbTokenCertificate.serialNumber).then(
      //     signature => {
      //       if (!signature) {
      //         this.toastr.error(this.message.getMessage('messages.error_not_find_certificate'));
      //         return;
      //       }
      //       this.sign.signature = signature;
      //       this.signUsb(this.sign);
      //     }
      //   ).catch(e => {
      //     if (e.errorCode) {
      //       if (e.errorCode === 401) {
      //         // ngươif dùng huỷ, không chọn cts
      //         return;
      //       }
      //     }
      //     this.toastr.error(this.message.getMessage('messages.error_not_find_certificate'));
      //   });
      // });
    } else {
      const filePath = {};
      let isSuccess = true;
      const mainContractAttachmentsNew = [];
      for await (const [index, img] of this.signProcessing.entries()) {
        if (this.isCancel) {
          isSuccess = false;
          break;
        }
        const sign = JSON.parse(JSON.stringify(this.sign));
        sign.position = JSON.stringify(img);
        const file = this.document.mainContractAttachments.find(ca => this.decodeId(ca.id) === img.fileId);
        sign.path = file && file.path ? file.path : null;
        sign.oldPath = filePath[img.fileId] ? filePath[img.fileId] : '';
        const rs = await this.anonymousSignService.createHashNoImage(sign, this.contractIdAndContractEnterpriseIdEncode).toPromise();
        if (this.contractIdAndContractEnterpriseIdEncode) {
          this.checkExpireTime();
        }
        if (rs && !rs.success) {
          isSuccess = false;
          this.signError = rs && rs.message ? rs.message : null;
          break;
        }
        if (rs && rs.data) {
          sign.path = rs.data.path;
          sign.signPdf = rs.data.signPdf;
          filePath[img.fileId] = rs.data.path;
          const contractAttachment = mainContractAttachmentsNew.find(ca => ca.id === file.id);
          if (!contractAttachment) {
            const contractAttachmentNew = JSON.parse(JSON.stringify(file));
            contractAttachmentNew.path = rs.data.path;
            mainContractAttachmentsNew.push(contractAttachmentNew);
          } else {
            contractAttachment.path = rs.data.path;
          }
          const signature = await anonymousSignHashAsyncNew(this, rs.data.hash, this.sessionId, this.usbTokenCertificate.serialNumber);
          if (!signature) {
            this.errorStatus = 'messages.error_not_find_certificate';
            isSuccess = false;
            break;
          }
          if (index === 0) {
            this.isCallDone = false;
          }
          sign.signature = signature;
          sign.position = JSON.parse(sign.position);
          sign.signPositions = this.signImages;
          sign.image = this.commonService.convertEmptyObjectToNull(sign.image);
          const resSign = await this.signUsb(sign, this.contractIdAndContractEnterpriseIdEncode);
          if (this.contractIdAndContractEnterpriseIdEncode) {
            this.checkExpireTime();
          }
          if (resSign && !resSign.success) {
            isSuccess = false;
            this.signError = resSign && resSign.message ? resSign.message : null;
            break;
          }
          if (!resSign || !resSign.data) {
            isSuccess = false;
            break;
          }
          if (!this.isCancel) {
            img.done = true;
          }
        } else {
          isSuccess = false;
          break;
        }
      }
      if (this.isCancel) {
        isSuccess = false;
      }
      const data = {
        signMethod: this.typeSelectCertificate,
        contractId: this.document.id,
        mainContractAttachments: mainContractAttachmentsNew,
        certificate: this.sign.certificate,
        hashKey: this.hashKey,
        tenantId: this.tenantId,
        signTransactionId: this.signTransactionId,
        userCancel: this.userCancel,
        message: this.messageSign
      }
      if (isSuccess) {
        this.isCallDone = true;
        const res = await this.anonymousSignService.signDone(data).toPromise();
        if (res && res.data) {
          this.onSignSuccess();
        } else {
          this.isCallDone = false;
        }
      } else {
        this.anonymousSignService.signCancel(data, this.contractIdAndContractEnterpriseIdEncode).subscribe(rs => {
          this.errorStatus = "messages.stop_sign_document";
        });
      }
      // this.anonymousSignService.createHashNoImage(this.sign).subscribe(rs => {
      //   this.sign.path = rs.data.path;
      //   this.sign.signPdf = rs.data.signPdf;
      //   // this.sign.signature = signHash(this, rs.data.hash);
      //   // this.sign.signature = anonymousSignHash(this, rs.data.hash, this.sessionId, this.usbTokenCertificate.serialNumber);
      //   // this.signUsb(this.sign);
      //   anonymousSignHashAsyncNew(this, rs.data.hash, this.sessionId, this.usbTokenCertificate.serialNumber).then(
      //     signature => {
      //       if (!signature) {
      //         this.toastr.error(this.message.getMessage('messages.error_not_find_certificate'));
      //         return;
      //       }
      //       this.sign.signature = signature;
      //       this.signUsb(this.sign);
      //     }
      //   ).catch(e => {
      //     if (e.errorCode) {
      //       if (e.errorCode === 401) {
      //         // ngươif dùng huỷ, không chọn cts
      //         return;
      //       }
      //     }
      //     this.toastr.error(this.message.getMessage('messages.error_not_find_certificate'));
      //   });
      // });
    }
  }

  async createHash(certUserBase64: string) {
    this.sign.certificate = certUserBase64;
    if (this.fileUpload) {
      const filePath = {};
      let isSuccess = true;
      const mainContractAttachmentsNew = [];
      const fileArr = new Set(this.signProcessing.map($ => $.fileId));
      for await (const [idx, fileId] of fileArr.entries()) {
        if (this.isCancel) {
          isSuccess = false;
          break;
        }
        const sign = JSON.parse(JSON.stringify(this.sign));
        const _dst$ = this.signProcessing.filter($ => $.fileId == fileId)
        sign.image = this.fileUpload;
        sign.position = JSON.stringify(_dst$[0]);
        sign.signPositions = _dst$;
        const file = this.document.mainContractAttachments.find(ca => this.decodeId(ca.id) === fileId);
        sign.path = file && file.path ? file.path : null;
        sign.oldPath = filePath[fileId] ? filePath[fileId] : '';

        let rs;
        if (this.indexSelect === 0 && this.fileUpload) {
          const newDate = await this.signDocumentService.getDateAsync().toPromise();
          if (!newDate || !newDate.data || !newDate.data.date) {
            return;
          }

          this.signConfig.signingTime.value = newDate.data.date;

          this.cd.detectChanges();
          let blob = null;
          try {
            let imageSize = this.setSizeFrameImage();
            blob = await this.imageGenerateService.genImage(this.signConfig, imageSize).toPromise();
          } catch (e) {
            console.log("call api error, use html to image", e);
            try {
              let imageSize = this.setSizeFrameImage();
              blob = await this.imageGenerateService.genImage(this.signConfig, imageSize).toPromise();
            } catch (e) {
              console.log("call api error, use html to image", e);
            }
          }
          if(!blob){
            this.toastr.error(this.message.getMessage('messages.error_proccessing'));
            isSuccess = false;
            break;
          }
          const newFile = new File([blob], 'lastImage.png', {type: 'image/png'});
          this.fileUpload = newFile;

          sign.image = this.fileUpload;

          rs = await this.anonymousSignService.createHashWithImageBase64(sign, this.contractIdAndContractEnterpriseIdEncode);

          if (this.contractIdAndContractEnterpriseIdEncode) {
            this.checkExpireTime();
          }

          if (rs && !rs.success) {
            isSuccess = false;
            this.signError = rs && rs.message ? rs.message : null;
          } else if (rs && rs.data) {
            sign.path = rs.data.path;
            sign.signPdf = rs.data.signPdf;
            filePath[fileId] = rs.data.path;
            const contractAttachment = mainContractAttachmentsNew.find(ca => ca.id === file.id);
            if (!contractAttachment) {
              const contractAttachmentNew = JSON.parse(JSON.stringify(file));
              contractAttachmentNew.path = rs.data.path;
              mainContractAttachmentsNew.push(contractAttachmentNew);
            } else {
              contractAttachment.path = rs.data.path;
            }
            const signature = await anonymousSignHashAsyncNew(this, rs.data.hash, this.sessionId, this.usbTokenCertificate.serialNumber);
            if (!signature) {
              this.errorStatus = 'messages.error_not_find_certificate';
              isSuccess = false;
              break;
            }
            if (idx === 0) {
              this.isCallDone = false;
            }
            sign.signature = signature;
            sign.position = JSON.parse(sign.position);
            sign.signPositions = this.signImages;
            sign.image = this.commonService.convertEmptyObjectToNull(sign.image);
            const resSign = await this.signUsb(sign, this.contractIdAndContractEnterpriseIdEncode);
            if (this.contractIdAndContractEnterpriseIdEncode) {
              this.checkExpireTime();
            }
            if (resSign && !resSign.success) {
              this.signError = resSign && resSign.message ? resSign.message : null;
              isSuccess = false;
              break;
            }
            if (!resSign || !resSign.data) {
              isSuccess = false;
              break;
            }
            if (!this.isCancel) {
              _dst$.forEach($ => $.done = true);
            }
          } else {
            isSuccess = false;
            break;
          }
        } else {
          rs = await this.anonymousSignService.createHashWithImageBase64(sign, this.contractIdAndContractEnterpriseIdEncode);
          if (this.contractIdAndContractEnterpriseIdEncode) {
            this.checkExpireTime();
          }

          if (rs && !rs.success) {
            isSuccess = false;
            this.signError = rs && rs.message ? rs.message : null;
            break;
          }
          if (rs && rs.data) {
            sign.path = rs.data.path;
            sign.signPdf = rs.data.signPdf;
            filePath[fileId] = rs.data.path;
            const contractAttachment = mainContractAttachmentsNew.find(ca => ca.id === file.id);
            if (!contractAttachment) {
              const contractAttachmentNew = JSON.parse(JSON.stringify(file));
              contractAttachmentNew.path = rs.data.path;
              mainContractAttachmentsNew.push(contractAttachmentNew);
            } else {
              contractAttachment.path = rs.data.path;
            }
            const signature = await anonymousSignHashAsyncNew(this, rs.data.hash, this.sessionId, this.usbTokenCertificate.serialNumber);
            if (!signature) {
              this.errorStatus = 'messages.error_not_find_certificate';
              isSuccess = false;
              break;
            }
            if (idx === 0) {
              this.isCallDone = false;
            }
            sign.signature = signature;
            sign.position = JSON.parse(sign.position);
            sign.signPositions = this.signImages;
            sign.image = this.commonService.convertEmptyObjectToNull(sign.image);
            const resSign = await this.signUsb(sign, this.contractIdAndContractEnterpriseIdEncode);
            if (this.contractIdAndContractEnterpriseIdEncode) {
              this.checkExpireTime();
            }
            if (resSign && !resSign.success) {
              this.signError = resSign && resSign.message ? resSign.message : null;
              isSuccess = false;
              break;
            }
            if (!resSign || !resSign.data) {
              isSuccess = false;
              break;
            }
            if (!this.isCancel) {
              _dst$.forEach($ => $.done = true);
            }
          } else {
            isSuccess = false;
            break;
          }
        }
      }
      if (this.isCancel) {
        isSuccess = false;
      }
      const data = {
        signMethod: this.typeSelectCertificate,
        contractId: this.document.id,
        mainContractAttachments: mainContractAttachmentsNew,
        certificate: this.sign.certificate,
        hashKey: this.hashKey,
        tenantId: this.tenantId,
        signTransactionId: this.signTransactionId,
        userCancel: this.userCancel,
        message: this.messageSign
      };
      if (isSuccess) {
        this.isCallDone = true;
        const res = await this.anonymousSignService.signDone(data).toPromise();
        if (res && res.data) {
          this.onSignSuccess();
        } else {
          this.isCallDone = false;
        }
      } else {
        this.anonymousSignService.signCancel(data, this.contractIdAndContractEnterpriseIdEncode).subscribe(rs => {
          this.errorStatus = "messages.stop_sign_document";
        });
      }
      // this.anonymousSignService.createHashWithImage(this.sign).subscribe(rs => {
      //   this.sign.path = rs.data.path;
      //   this.sign.signPdf = rs.data.signPdf;
      //   // this.sign.signature = signHash(this, rs.data.hash);
      //   // this.sign.signature = anonymousSignHash(this, rs.data.hash, this.sessionId, this.usbTokenCertificate.serialNumber);
      //   // this.signUsb(this.sign);
      //   anonymousSignHashAsyncNew(this, rs.data.hash, this.sessionId, this.usbTokenCertificate.serialNumber).then(
      //     signature => {
      //       if (!signature) {
      //         this.toastr.error(this.message.getMessage('messages.error_not_find_certificate'));
      //         return;
      //       }
      //       this.sign.signature = signature;
      //       this.signUsb(this.sign);
      //     }
      //   ).catch(e => {
      //     if (e.errorCode) {
      //       if (e.errorCode === 401) {
      //         // ngươif dùng huỷ, không chọn cts
      //         return;
      //       }
      //     }
      //     this.toastr.error(this.message.getMessage('messages.error_not_find_certificate'));
      //   });
      // });
    } else {
      const filePath = {};
      let isSuccess = true;
      const mainContractAttachmentsNew = [];
      const fileArr = new Set(this.signProcessing.map($ => $.fileId));
      for await (const [idx, fileId] of fileArr.entries()) {
        if (this.isCancel) {
          isSuccess = false;
          break;
        }
        const sign = JSON.parse(JSON.stringify(this.sign));
        const _dst$ = this.signProcessing.filter($ => $.fileId == fileId);
        sign.position = JSON.stringify(_dst$[0]);
        sign.signPositions = _dst$;
        const file = this.document.mainContractAttachments.find(ca => this.decodeId(ca.id) === fileId);
        sign.path = file && file.path ? file.path : null;
        sign.oldPath = filePath[fileId] ? filePath[fileId] : '';
        const rs = await this.anonymousSignService.createHashNoImage(sign, this.contractIdAndContractEnterpriseIdEncode).toPromise();
        if (this.contractIdAndContractEnterpriseIdEncode) {
          this.checkExpireTime();
        }
        if (rs && !rs.success) {
          isSuccess = false;
          this.signError = rs && rs.message ? rs.message : null;
          break;
        }
        if (rs && rs.data) {
          sign.path = rs.data.path;
          sign.signPdf = rs.data.signPdf;
          filePath[fileId] = rs.data.path;
          const contractAttachment = mainContractAttachmentsNew.find(ca => ca.id === file.id);
          if (!contractAttachment) {
            const contractAttachmentNew = JSON.parse(JSON.stringify(file));
            contractAttachmentNew.path = rs.data.path;
            mainContractAttachmentsNew.push(contractAttachmentNew);
          } else {
            contractAttachment.path = rs.data.path;
          }
          const signature = await anonymousSignHashAsyncNew(this, rs.data.hash, this.sessionId, this.usbTokenCertificate.serialNumber);
          if (!signature) {
            this.errorStatus = 'messages.error_not_find_certificate';
            isSuccess = false;
            break;
          }
          if (idx === 0) {
            this.isCallDone = false;
          }
          sign.signature = signature;
          sign.position = JSON.parse(sign.position);
          sign.signPositions = this.signImages;
          sign.image = this.commonService.convertEmptyObjectToNull(sign.image);
          const resSign = await this.signUsb(sign, this.contractIdAndContractEnterpriseIdEncode);
          if (this.contractIdAndContractEnterpriseIdEncode) {
            this.checkExpireTime();
          }
          if (resSign && !resSign.success) {
            isSuccess = false;
            this.signError = resSign && resSign.message ? resSign.message : null;
            break;
          }
          if (!resSign || !resSign.data) {
            isSuccess = false;
            break;
          }
          if (!this.isCancel) {
            _dst$.forEach($ => $.done = true);
          }
        } else {
          isSuccess = false;
          break;
        }
      }
      if (this.isCancel) {
        isSuccess = false;
      }
      const data = {
        signMethod: this.typeSelectCertificate,
        contractId: this.document.id,
        mainContractAttachments: mainContractAttachmentsNew,
        certificate: this.sign.certificate,
        hashKey: this.hashKey,
        tenantId: this.tenantId,
        signTransactionId: this.signTransactionId,
        userCancel: this.userCancel,
        message: this.messageSign
      }
      if (isSuccess) {
        this.isCallDone = true;
        const res = await this.anonymousSignService.signDone(data).toPromise();
        if (res && res.data) {
          this.onSignSuccess();
        } else {
          this.isCallDone = false;
        }
      } else {
        this.anonymousSignService.signCancel(data, this.contractIdAndContractEnterpriseIdEncode).subscribe(rs => {
          this.errorStatus = "messages.stop_sign_document";
        });
      }
      // this.anonymousSignService.createHashNoImage(this.sign).subscribe(rs => {
      //   this.sign.path = rs.data.path;
      //   this.sign.signPdf = rs.data.signPdf;
      //   // this.sign.signature = signHash(this, rs.data.hash);
      //   // this.sign.signature = anonymousSignHash(this, rs.data.hash, this.sessionId, this.usbTokenCertificate.serialNumber);
      //   // this.signUsb(this.sign);
      //   anonymousSignHashAsyncNew(this, rs.data.hash, this.sessionId, this.usbTokenCertificate.serialNumber).then(
      //     signature => {
      //       if (!signature) {
      //         this.toastr.error(this.message.getMessage('messages.error_not_find_certificate'));
      //         return;
      //       }
      //       this.sign.signature = signature;
      //       this.signUsb(this.sign);
      //     }
      //   ).catch(e => {
      //     if (e.errorCode) {
      //       if (e.errorCode === 401) {
      //         // ngươif dùng huỷ, không chọn cts
      //         return;
      //       }
      //     }
      //     this.toastr.error(this.message.getMessage('messages.error_not_find_certificate'));
      //   });
      // });
    }
  }

  async signUsb(certificate: any, hashLink?: string) {
    if (this.isSignDigitalCertificate) {
      if (certificate.image) {
        delete certificate.image;
      }
    }
    const res = await this.anonymousSignService.signUsb(certificate, hashLink).toPromise();
    return res;
  }

  preProcessCloudCa() {
  }


  private onSignSuccess() {
    this.toastr.success(this.message.getMessage('messages.sign_success'));
    this.success = true;
    this.dialog.closeAll();
    this.backToPrePage();
  }

  backToPrePage(data?) {
    if (this.contractIdAndContractEnterpriseIdEncode) {
      if (this.isSignDigitalCertificate && !data) {
        this.router.navigate(['/approval/success']);
      } else
        this.router.navigate([`sign-anonymous/${this.hashKey}/${this.tenantId}/${this.contractIdAndContractEnterpriseIdEncode}/detail`]);
    } else {
      if (this.isSignDigitalCertificate && !data) {
        this.router.navigate(['/approval/success']);
      } else
        this.router.navigate([`/sign-anonymous/${this.hashKey}/${this.tenantId}/detail`]);
    }
  }

  onClickSignButton() {
    // this.isClickSignBuuton = true;
    // if (this.isSelectPosition) {
    //   this.toastr.error(this.message.getMessage('messages.need_choose_position'));
    //   return;
    // }
    // if (this.document.mainContractAttachments && this.document.mainContractAttachments.length) {
    //   const fileName = [];
    //   let indexError = null;
    //   let filePathError = null;
    //   const fileError = [];
    //   this.document.mainContractAttachments.forEach((ca, index) => {
    //     const fileId = this.decodeId(ca.id);
    //     const sign = this.signPosition.filter(sign => {
    //       return sign.fileId === fileId;
    //     });
    //     if (!sign.length) {
    //       if (!indexError) {
    //         indexError = index;
    //         filePathError = ca.path;
    //       }
    //       fileError.push(ca.id);
    //       fileName.push(`'${ca.fileName}'`);
    //     }
    //   });
    //   if (fileName.length) {
    //     this.changeFile(filePathError, indexError);
    //     this.fileError = fileError;
    //     this.toastr.error(this.commonService.format(this.message.getMessage('messages.need_create_sign_file'), fileName.join(', ')).replace(/&quot;/g, "'"));
    //     return;
    //   }
    // }

    // const positionConvert = [];
    // if (this.imageData && this.imageData.length > 0) {
    //   this.imageData.map(pos => {
    //     positionConvert.push({
    //       positionY: pos.positionY,
    //       pageNumber: pos.pageNumber,
    //       positionX: pos.positionX,
    //       widthRectangle: pos.widthRectangle,
    //       heightRectangle: pos.heightRectangle,
    //       signType: "combine"
    //     });
    //   });
    // }

    // this.sign = {
    //   ...this.selectedCert,
    //   hashKey: this.hashKey,
    //   tenantId: this.tenantId,
    //   phoneNumber: this.simCaPhoneNumber,
    //   contractId: this.document.id,
    // };
    // if (this.typeSelectCertificate === this.signMethod.SIGN_OTP) {
    //   this.sign.phoneNumber = this.otpPhoneNumber;
    // }
    // // const position = JSON.parse(localStorage.getItem('SignPosition'));
    // // if (position) {
    // //   let imageSort = [];
    // //   for (const contractAttachment of this.document.mainContractAttachments) {
    // //     const fileId = this.decodeId(contractAttachment.id);
    // //     const imageData = position.filter(item => {
    // //       item.positionX = item.x ? item.x : item.positionX ? item.positionX : null;
    // //       item.positionY = item.y ? item.y : item.positionY ? item.positionY : null;
    // //       item.widthRectangle = item.width ? item.width : item.widthRectangle ? item.widthRectangle : null;
    // //       item.heightRectangle = item.height ? item.height : item.heightRectangle ? item.heightRectangle : null;
    // //       return item.fileId === fileId
    // //     });
    // //     imageSort = imageSort.concat(imageData);
    // //   }
    // //   const imageData = imageSort.filter(item => { if (item.signType === 'combine') { item.signType = 'image'; } return item.signType !== 'digital' });
    // //   this.signProcessing = JSON.parse(JSON.stringify(imageData));
    // // } else {
    // let imageSort = [];
    // // this.contractSignEntityList = _.cloneDeep(this.imageData);
    // for (const contractAttachment of this.document.mainContractAttachments) {
    //   const fileId = this.decodeId(contractAttachment.id);
    //   const imageData = this.imageData.filter(item => {
    //     return item.fileId === fileId
    //   });
    //   imageSort = imageSort.concat(imageData);
    // }
    // let imageData = []
    // const arr1 = [];
    // for (let i = 0; i < imageSort.length; i++) {
    //   for (let j = 0; j < imageSort.length; j++) {
    //     if (i !== j && imageSort[j].positionX == imageSort[i].positionX
    //       && imageSort[j].positionY == imageSort[i].positionY
    //       && imageSort[j].pageNumber == imageSort[i].pageNumber
    //       && imageSort[j].widthRectangle == imageSort[i].widthRectangle
    //       && imageSort[j].heightRectangle == imageSort[i].heightRectangle
    //       && imageSort[j].zoom == imageSort[i].zoom
    //       && imageSort[j].fileId == imageSort[i].fileId
    //       && imageSort[j].signType !== imageSort[i].signType) {
    //       arr1.push(imageSort[i])
    //       imageSort.splice(j, 1);
    //       imageSort.splice(i, 1);
    //       i--
    //       break;
    //     }
    //   }
    // }

    // arr1.map(item => item.signType = 'image')

    // imageData = ([...imageSort, ...arr1]);
    // let imagePreSort = [];
    // for (const contractAttachment of this.document.mainContractAttachments) {
    //   const fileId = this.decodeId(contractAttachment.id);
    //   let imageList = imageData.filter(item => {
    //     return item.fileId === fileId
    //   });
    //   imageList = imageList.sort((a, b) => a.pageNumber === b.pageNumber ?
    //     Number(b.positionY) - Number(a.positionY) :
    //     Number(a.pageNumber) - Number(b.pageNumber));
    //   imagePreSort = imagePreSort.concat(imageList);
    // }
    if (this.document.isConfirmBCT) {
      this.signImages = this.signImages.map((item) => {
        item['signTransactionId'] = this.signTransactionId;
        return item;
      })
    }
    this.signProcessing = JSON.parse(JSON.stringify(this.signImages));
    // }
    // this.isCallDone = true;

    // if (this.current === 3 && this.isShowEKYC) {
    //   this.onIdentityEKYC();
    //   return;
    // }

    if (this.typeSelectCertificate !== this.signMethod.SIGN_OTP) {
      const dialog = this.dialog.open(SigningDialogComponent, {
        width: '80%',
        disableClose: true,
        data: this
      });
      dialog.afterClosed().subscribe(() => {
        this.signProcessing = [];
        this.errorStatus = null;
        this.signError = null;
        this.isCancel = false;
        this.isCallDone = false;
        this.dialog.closeAll();
      });
    }
    if (!this.isShowImage || !this.isSignDigitalCertificate) {
      fetch('../../../../../../../assets/images/arrowLeft.png')
        .then(response => response.blob())
        .then(blob => {
          this.fileUpload = new File([blob], 'fileNameGoesHere', { type: 'image/png' });
          if (this.fileUpload) {
            this.onClickConfirmButtonImage();
          }
        })
        .catch(error => {
          console.error('Lỗi khi đọc tệp ảnh', error);
        });
    } else {
      if (!this.fileUpload) {
        this.onClickConfirmButtonNoImage();
      } else {
        // this.sign = {
        //   ...this.sign,
        //   image: this.fileUpload,
        // };
        this.onClickConfirmButtonImage();
      }
    }
    // if (!this.fileUpload) {
    //
    // } else {
    //
    // }
  }

  onSelectImageSignMethod(type: number) {
    this.isDisableNextButton = false;
  }

  onChangeSubType(cert: any) {

  }

  onClickBtnCancel(data?) {
    this.backToPrePage(data);
  }

  nzSelectChange(index: number) {
    this.indexSelect = index;
    if (this.selectedCert.typeCertificate !== this.signMethod.SIGN_NO_CERT && this.typeSelectCertificate !== this.signMethod.SIGN_NO_CERT) {
      if (index === 2) {
        this.isSelectDrawImage = true;
        this.isDisableNextButton = true;
        this.canvasService.setIsDisableBtnDeleteCanvas(true);
        this.systemImageSign = false;
      }
      if (index === 1) {
        this.isDisableNextButton = true;
        this.fileUpload = null;
        this.avatarUrl = null;
        this.isSelectDrawImage = false;
        this.systemImageSign = false;
      }
      if (index === 0) {
        this.systemImageSign = true;
        this.isDisableNextButton = false;
        this.isSelectDrawImage = false;
        this.fileUpload = null;
        this.imageUrlPreview = '';
        setTimeout(() => {
          this.setFontSize(imageConfigViewScaleId);
          this.setFontSize(imageConfigRenderId);
        }, 100);
      } else {
        this.fileUpload = null;
        this.imageUrlPreview = '';
      }
    } else {
      if (index === 1) {
        this.isSelectDrawImage = true;
        this.isDisableNextButton = true;
        this.canvasService.setIsDisableBtnDeleteCanvas(true);
      }
      if (index === 0) {
        this.systemImageSign = true;
        this.isSelectDrawImage = false;
        this.isDisableNextButton = true;
        this.fileUpload = null;
        this.avatarUrl = null;
        this.imageUrlPreview = '';
        setTimeout(() => {
          this.setFontSize(imageConfigViewScaleId);
          this.setFontSize(imageConfigRenderId);
        }, 100);
      }
    }
  }

  onChangeSelectCertificateType(value: any) {
    this.typeCertificate = value;
    this.selectedCert = Object.assign(this.selectedCert, {typeCertificate: this.typeCertificate});

    if (value === this.signMethod.SIGN_NO_CERT)
      this.isDisableNextButton = false;
    else
      this.isDisableNextButton = true;

    if (value === this.signMethod.SIGN_OTP) {
      this.changePhone(this.otpPhoneNumber);
    }

    if (value === this.signMethod.SIGN_OTP && this.supportEkyc) {
      this.isReloadCamera = false;
    } else {
      this.isReloadCamera = true;
    }
  }

  changePhone(value) {
    let regexpNumber = new RegExp(this.otpPhoneNumberPattern);
    if (value.trim() == '' || value === null || !regexpNumber.test(value.trim())) {
      this.isDisableNextButton = true;
    } else
      this.isDisableNextButton = false;
    this.signConfig.phoneNumber.value = this.otpPhoneNumber;
  }

  clear() {
    this.otpPhoneNumber = null;
    this.isDisableNextButton = true
  }

  getCertificateOfSimCA() {
    // this.simCaPhoneNumber = this.digitalCertificateService.formatPhoneNumber(this.simCaPhoneNumber);
    this.anonymousSignService.anonymousGetlistCertSimCa(this.hashKey, this.simCaPhoneNumber, this.tenantId, this.contractIdAndContractEnterpriseIdEncode).pipe(first()).subscribe(rs => {
      this.checkDisplayMessageError(rs.code);
      if (rs.data.length > 0) {
        this.listOfDataSimCa = rs.data.map((item, index) => {
          return {
            ...item,
            STT: index + 1
          };
        });
      } else {
        this.toastr.error(this.message.getMessage('validation.no_valid_certificate_simCA'));
      }
    }, error => {
    });
  }

  onSelectedCert(event: any, cert) {
    if (event === true) {
      this.selectedCertSimCa = cert;
      this.selectedCert = cert;
      this.signConfig.enterpriseName.value = this.selectedCert.certificateName;
      this.signConfig.email.value = this.selectedCert.email;
      this.isDisableNextButton = false;
      this.listOfDataSimCa = this.listOfDataSimCa.map(item => {
        return {...item, checked: cert.STT === item.STT};
      });
    } else {
      this.isDisableNextButton = true;
      this.selectedCertSimCa = null;
    }
  }

  onSelectedCloudCaCert(event: any, cert) {
    if (event === true) {
      this.selectedCert = cert;
      this.signConfig.enterpriseName.value = this.selectedCert.certificateName;
      this.signConfig.email.value = this.selectedCert.email;
      this.isDisableNextButton = false;
      this.cloudCaDataSource = this.cloudCaDataSource.map(item => {
        return {...item, checked: cert.STT === item.STT};
      });
    } else {
      this.isDisableNextButton = true;
      this.selectedCertSimCa = null;
    }
  }

  getInformCertificateFromFile(baseString: string, file) {
    this.digitalCertificateService.getInformCertificateFromFile({
      certRawdata: baseString
    }).subscribe(rs => {
      this.errorStatus = null;
      this.fileUpload = file;
      this.usbTokenCertificate = {
        ...this.usbTokenCertificate,
        activeDate: rs.data.activeDate,
        expireDate: rs.data.expireDate,
        certificateName: rs.data.certificateName,
        serialNumber: rs.data.serialNumber,
        distinguishedName: rs.data.distinguishedName,
        issuedBy: rs.data.issuedBy,
        certRawdata: baseString,
        taxCode: rs.data.taxCode,
        email: rs.data.email
      };
    });
  }

  private reset() {
    this.inputUploadFile.nativeElement.value = '';
  }

  getFile(evt) {
    if (typeof (FileReader) !== 'undefined') {
      const file = evt.target.files[0];
      // Check format of file
      if (!this.checkFormatTypeFile(file)) {
        // Check size of file
        if (!this.checkSize(file.size)) {
          this.usbTokenCertificate.fileName = file.name;
          const reader = new FileReader();
          reader.onload = (e: any) => {
            // Base64 string of file
            const binaryData = e.target.result;
            this.usbTokenCertificate.certRawdata = window.btoa(binaryData);
            this.getInformCertificateFromFile(window.btoa(binaryData), file);
          };
          // Read in the image file as a data URL.
          reader.readAsBinaryString(file);
        }
      } else {
        if (!this.toastr.findDuplicate(this.message.getMessage('validation.file_format_error'), true, true)) {
          this.toastr.error(this.message.getMessage('validation.file_format_error'));
        }
      }
      this.reset();
    }
  }

  checkFormatTypeFile(file): boolean {
    if (file.type !== 'application/x-x509-ca-cert') {
      this.errorFormatTypeFile = true;
      return true;
    } else {
      return false;
    }
  }

  private checkSize(fileSize): boolean {
    if (fileSize > 5242880) {
      this.maxSizeInput = true;
      if (!this.toastr.findDuplicate(this.message.getMessage('messages.error_file_5mb'), true, true)) {
        this.toastr.error(this.message.getMessage('messages.error_file_5mb'));
      }
      return true;
    } else {
      this.maxSizeInput = false;
      return false;
    }
  }

  onGetCertificate() {
    this.blockUI.start('');
    initPluginCertificate(this);
    this.isDisableNextButton = false;
  }

  downloadSignPlugin(os?: string) {
    this.anonymousSignService.getSignPluginName(this.hashKey).subscribe(filename => {
      this.digitalCertificateService.downloadSignPlugin(os).subscribe(rs => {
        this.downLoadFile(rs, 'application/octet-stream', filename);
      });
    });
  }

  getLinkDownload(os?: string) {
    return this.digitalCertificateService.linkDownloadPluginSign(os);
  }

  downLoadFile(data: any, type: string, fileName: string) {
    const blob = new Blob([data], {type});
    if (window.top.navigator.msSaveOrOpenBlob) {
      // Store Blob in IE
      window.top.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      // Store Blob in others
      const tA = document.body.appendChild(document.createElement('a'));
      tA.href = URL.createObjectURL(blob);
      tA.download = fileName;
      tA.style.display = 'none';
      tA.click();
      tA.parentNode.removeChild(tA);
    }
  }

  createATag(link: string, title: string) {
    return '<a target="_blank" href="' + link + '">' + title + '</a>';
  }

  showErrMsgTransle(msg: string, showToast?: boolean) {
    if (msg === 'messages.not_initPlugin') {
      const link = this.linkDownSignPlugin();
      // console.log(this.createATag(this.linkDownSignPlugin('WINDOWS'), 'Windows, '));
      msg = "messages.initPlugin_faile"
      if (showToast) {
        this.blockUI.stop();

        this.dialog.open(AlertComponent, {
          width: '370px',
          data: this.message.getMessage(msg)
            // + '<a target="_blank" href="' + link + '"><b> ' + this.message.getMessage('messages.here') + '</b></a>'
            + this.createATag(this.linkDownSignPlugin('WINDOWS'), 'Windows, ') + this.createATag(this.linkDownSignPlugin('MACOS'), 'MacOS, ') + this.createATag(this.linkDownSignPlugin('LINUX'), 'ViettelOS')
        });
        return;
      }
      this.signError = this.message.getMessage(msg)
        // + '<a target="_blank" href="' + link + '"><b> ' + this.message.getMessage('messages.here') + '</b></a>';
        + this.createATag(this.linkDownSignPlugin('WINDOWS'), 'Windows, ') + this.createATag(this.linkDownSignPlugin('MACOS'), 'MacOS, ') + this.createATag(this.linkDownSignPlugin('LINUX'), 'ViettelOS')

    } else {
      if (showToast) {
        this.blockUI.stop();
        this.toastr.error(this.message.getMessage(msg));
        return;
      }
      // this.blockUI.stop();
      this.errorStatus = msg;
    }
  }

  setSerialNumber(value) {
    this.usbTokenCertificate.serialNumber = value;
  }

  setIssuedTo(value) {
    this.usbTokenCertificate.issuedTo = value;
  }

  setDistinguishedName(value) {
    this.usbTokenCertificate.distinguishedName = value;
  }

  setTaxCode(value) {
    this.usbTokenCertificate.taxCode = value;
  }

  setIssuedBy(value) {
    this.usbTokenCertificate.issuedBy = value;
  }

  setCertRawdata(value) {
    this.usbTokenCertificate.certRawdata = value;
  }

  setActiveDate(value) {
    this.usbTokenCertificate.activeDate = new Date(value);
  }

  setExpireDate(value) {
    this.usbTokenCertificate.expireDate = new Date(value);
  }

  setSessionId(value) {
    this.sessionId = value;
  }

  setCertData(data) {
    let dataValid = true;
    for (const [key, value] of Object.entries(data)) {
      if (!value) {
        dataValid = false;
        break;
      }
    }
    if (dataValid) {
      this.certData = data;
    } else {
      this.toastr.error(this.message.getMessage('messages.certificate_info_not_valid'));
      this.usbTokenCertificate = {
        certRawdata: '',
        taxCode: '',
        serialNumber: '',
        issuedTo: '',
        issuedBy: '',
        expireDate: new Date(),
        activeDate: new Date(),
        fileName: '',
        certificateName: '',
        distinguishedName: '',
        email: ''
      };
      this.isDisableNextButton = true;
      this.sessionId = null;
    }
  }

  setActiveContinueButton() {
    this.isDisableNextButton = false;
  }

  genStampContent() {
    let contentNode: string;
    const padding = 10;
    const zoom = this.zoomLevel / 100;
    let widthRectangle = this.widthRectangle * zoom;
    let heightRectangle = this.heightRectangle * zoom;

    widthRectangle -= padding * zoom * 2;
    heightRectangle -= padding * zoom * 2;

    let height = widthRectangle;
    let width = heightRectangle;
    const ratio = this.imagePreviewWidth / this.imagePreviewHeight;
    if (this.imagePreviewWidth > this.imagePreviewHeight) {
      width = widthRectangle;
      height = width / ratio;
      if (height > heightRectangle) {
        height = heightRectangle;
        width = height * ratio;
      }
    } else {
      height = heightRectangle;
      width = height * ratio;
    }

    const heightPx = `${height}px`;
    const widthPx = `${width}px`;
    let contentInsideNode = ''
    if (this.systemImageSign) {
      contentInsideNode = `
      <img draggable="false" src="${this.imageUrlPreview}" style="transform: scale(${this.signConfig.signaturePosition.value === 'top' || this.signConfig.signaturePosition.value === 'bottom' ? (heightRectangle + 20) / this.heightImageRender : (widthRectangle + 20) / this.widthImageRender}); display: flex; justify-content: flex-end; align-items: flex-start; object-fit: cover;"/>
       `;
    } else {
      contentInsideNode = `
               <img draggable="false" src="${this.imageUrlPreview}" style="height: ${heightPx};width: ${widthPx}; max-width: ${this.signConfig.signaturePosition.value === 'left' || this.signConfig.signaturePosition.value === 'right' ? '1386px' : 'none'}; max-height: ${this.signConfig.signaturePosition.value === 'top' || this.signConfig.signaturePosition.value === 'bottom' ? '538px' : 'none'}; margin: auto; display: flex; justify-content: flex-end; align-items: flex-start;"/>
                `;
    }

    if (this.fileUpload) {
      // tslint:disable-next-line:max-line-length
      contentNode = `
                 <div id="notify_outside" style="position: absolute;top: -40px;left: 33px;color: red;">${this.translateService.instant('messages.click_to_select_sign_position')}</div>
                 ${contentInsideNode}
                  `;
    } else {
      if (this.typeSelectCertificate === this.signMethod.SIGN_SIM_CA || this.typeSelectCertificate === this.signMethod.CLOUD_CA) {
        contentNode = `
        <div>
               <div id="notify_outside" style="position: absolute;top: -40px;left: 60px;color: red;">${this.translateService.instant('messages.click_to_select_sign_position')}</div>
              ${this.translateService.instant('enterprise_contract.image_signing.no_image.signed_by')} ${this.selectedCert.certificateName}
              <br/>
              ${this.translateService.instant('enterprise_contract.image_signing.no_image.signed_date')} ${this.dateNow}
         </div>
      `;
      } else if (this.typeSelectCertificate === this.signMethod.SIGN_NO_CERT) {
        contentNode = `
        <div>
               <div id="notify_outside" style="position: absolute;top: -40px;left: 60px;color: red;">${this.translateService.instant('messages.click_to_select_sign_position')}</div>
              ${this.translateService.instant('enterprise_contract.image_signing.no_image.signed_by')} ${this.enterpriseName}
              <br/>
              ${this.translateService.instant('enterprise_contract.image_signing.no_image.signed_date')} ${this.dateNow}
              ${this.isNotAttestedUser ? '' : '<br/>'}
              ${this.isNotAttestedUser ? '' : this.translateService.instant('enterprise_contract.image_signing.no_image.verified_info')}
         </div>
      `;
      } else if (this.typeSelectCertificate === this.signMethod.SIGN_OTP) {
        contentNode = `
          <div>
                <div id="notify_outside" style="position: absolute;top: -40px;left: 33px;color: red;">${this.translateService.instant('messages.click_to_select_sign_position')}</div>
                  ${this.translateService.instant('enterprise_contract.image_signing.no_image.signed_by')} ${this.enterpriseName}
                  <br/>
                  ${this.translateService.instant('enterprise_contract.image_signing.no_image.signed_phone')} ${this.otpPhoneNumber}
                  <br/>
                  ${this.translateService.instant('enterprise_contract.image_signing.no_image.signed_date')} ${this.dateNow}
                  ${this.isNotAttestedUser ? '' : '<br/>'}
                  ${this.isNotAttestedUser ? '' : this.translateService.instant('enterprise_contract.image_signing.no_image.verified_info')}
                </div>
          `;
      } else {
        contentNode = `<div>
              <div id="notify_outside" style="position: absolute;top: -40px;left: 33px;color: red;">${this.translateService.instant('messages.click_to_select_sign_position')}</div>
              ${this.translateService.instant('enterprise_contract.image_signing.no_image.signed_by')} ${this.selectedCert.issuedTo}
              <br/>
              ${this.translateService.instant('enterprise_contract.image_signing.no_image.signed_date')} ${this.dateNow}
            </div>`;
      }
    }
    return contentNode;
  }

  processSignOTP() {
    this.sign = {
      ...this.selectedCert,
      hashKey: this.hashKey,
      tenantId: this.tenantId,
      phoneNumber: this.simCaPhoneNumber,
      contractId: this.document.id,
    };
    if (this.typeSelectCertificate === this.signMethod.SIGN_OTP) {
      this.sign.phoneNumber = this.otpPhoneNumber;
    }
    let signMethod = this.typeSelectCertificate;
    if (this.isShowEKYC) {
      if (this.ekycSupportConfig === 1) {
        signMethod = EnumSignMethod.SIGN_OTP_EKYC;
      } else if (this.ekycSupportConfig === 2) {
        signMethod = EnumSignMethod.SIGN_OTP_EKYC_ADVANCED;
      }
    }
    let request = {
      signMethod: signMethod,
      signPositions: this.signImages
    }
    this.anonymousSignService.generateTransaction(this.hashKey, this.otpPhoneNumber, this.tenantId, request, this.contractIdAndContractEnterpriseIdEncode).subscribe(rs => {
      this.checkDisplayMessageError(rs.code);
      if (!rs.success) {
        if (rs.code === ErrorCode.OutOfMoneyOtp) {
          this.openDialogOutOfMoneyOtp(this.message.getMessage('messages.otp_out_of_money'));
        } else if (rs.code === ErrorCode.OutOfMoneyOtpNew) {
          this.openDialogOutOfMoneyOtp(this.message.getMessage('messages.otp_out_of_money_new'));
          // this.toastr.error(this.message.getMessage('messages.otp_out_of_money_new'));
        } else {
          this.toastr.error(rs.message);
        }
      } else {
        this.openDialogConfirmSignOTP(rs.data);
      }
    });
  }

  openDialogOutOfMoneyOtp(message) {
    const confirmDialog = this.dialog.open(NotifyWarningComponent, {
      data: message
    });
    confirmDialog.afterClosed().subscribe(() => {
      if (this.current > 0) {
        this.current = 1;
        this.pre()
      }
    });
  }

  openDialogConfirmSignOTP(transactionId: string) {
    let signMethod = this.typeSelectCertificate;
    if (this.isShowEKYC) {
      if (this.ekycSupportConfig === 1) {
        signMethod = EnumSignMethod.SIGN_OTP_EKYC;
      } else if (this.ekycSupportConfig === 2) {
        signMethod = EnumSignMethod.SIGN_OTP_EKYC_ADVANCED;
      }
    }
    let request = {
      signMethod: signMethod,
      signPositions: this.signImages
    }

    const dataCancel = {
      signMethod: this.typeSelectCertificate,
      contractId: this.document.id,
      mainContractAttachments: [],
      certificate: this.sign.certificate,
      hashKey: this.hashKey,
      tenantId: this.tenantId,
      phoneNumber: this.simCaPhoneNumber,
      serialNumber: this.selectedCert.serialNumber,
      transactionId: transactionId,
      userCancel: true,
    };
    this.dialogRef = this.dialog.open(ConfirmSignOtpWithImageComponent, {
      width: '40%',
      data: {
        documentId: this.sign.contractId,
        transaction: transactionId,
        selectedPhone: this.otpPhoneNumber,
        listSignPosition: JSON.stringify(this.imageData),
        image: this.fileUpload,
        anonymousOtp: true,
        hashKey: this.hashKey,
        tenantId: this.tenantId,
        function: this.processSignOTPAfterDialogClose.bind(this),
        supportEkyc: this.supportEkyc,
        request: request,
        signingInteval: this.signingInteval,
        openSigningDialog: this.openSigningDialog,
        dataCancel: dataCancel,
        hashLink: this.contractIdAndContractEnterpriseIdEncode
      }
    });

    this.dialogRef.afterClosed().subscribe((ref) => {
      if (ref) {
        const dialog = this.dialog.open(SigningDialogComponent, {
          width: '80%',
          disableClose: true,
          data: this
        });
        dialog.afterClosed().subscribe(() => {
          this.signProcessing = [];
          this.errorStatus = null;
          this.signError = null;
          this.isCancel = false;
          this.isCallDone = false;
          this.dialog.closeAll();
        });
      }
      // if (this.dialogRef.componentInstance.sign) {
      //   this.processSignOTPAfterDialogClose(this.dialogRef.componentInstance.sign);
      // }
    });
  }

  viewDocumentsUpload() {
    if (this.document) {
      const firstFile = this.document.mainContractAttachments[0];
      this.pdfSrc = this.listPdfSrc[firstFile.path];
    }
    // return this.anonymousSignService.getViewPdfsForDocument(this.hashKey, this.tenantId).subscribe(async (res) => {
    //   if (!res.data) {
    //     return;
    //   }
    //   const fileSrc = [];
    //   const files = [];
    //   for await (const [index, item] of res.data.entries()) {
    //     const file = new Blob([new Uint8Array(item.bytes)], {type: 'application/pdf'});
    //     files.push(file);
    //     const base64 = await this.blobToBinary(file);
    //     fileSrc.push(base64);
    //   }
    //   if (fileSrc.length > 0) {
    //     this.fileSrc = fileSrc;
    //     this.pdfSrc = fileSrc[0];
    //   }
    // });
  }

  blobToBinary(blob: Blob) {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.onload = (e: any) => {
        resolve(e.target.result);
      };
      reader.readAsArrayBuffer(blob);
    })
  }

  changeFile(filePath: string, index: number) {
    this.isSelectPosition = false;
    const nodeOther = document.getElementById('show-frames-notification');
    if (nodeOther) {
      nodeOther.remove();
    }
    this.pageCurrent = 1;
    this.activeFile = index;
    //siten cmt: trùng logic với checkSignManual()
    // const id = this.document.mainContractAttachments[index].id;
    // const fileId = this.decodeId(id);
    // const findSign = this.signPosition.filter(sign => {
    //   return sign.fileId === fileId;
    // });
    // if (!findSign.length) {
    //   this.onStamped();
    // }
    this.checkSignManual();
    // if (this.fileSrc.length) {
    //   this.pdfSrc = this.fileSrc[index];
    // }
    if (this.listPdfSrc) {
      this.pdfSrc = this.listPdfSrc[filePath];
    }
  }


  decodeId(id: string) {
    const idDecode = atob(id);
    const findNumber = idDecode.match(/[0-9]{1,}/g);
    if (findNumber && findNumber.length) {
      return Number(findNumber[findNumber.length - 1]);
    }
    return null;
  }

  checkSignManual() {
    const id = this.document.mainContractAttachments[this.activeFile].id;
    const fileId = this.decodeId(id);
    const signs = this.signPosition.filter(sign => {
      return sign.fileId === fileId;
    });
    if (signs.length > 0) {
      this.isAllowSelectSignPosition = false;
      this.isSelectPosition = false;
      if (signs.length === 1 && signs[0].signType === this.signPositionTypes.DIGITAL) {
        this.onlyDigital = true;
      } else {
        this.onlyDigital = false;
      }
      // siten comment do code signType luôn khác COMBINE
      // if (signs.length === 1 && signs[0].signType === this.signPositionTypes.COMBINE) {
      //   this.isAllowSelectSignPosition = true;
      // }
    } else {
      this.isAllowSelectSignPosition = true;
      this.onStamped();
    }
  }

  checkFileNotHaveSign(id: string) {
    return this.fileError.includes(id);
  }

  signCancel() {
    this.imageData = this.contractSignEntityList;
    const dialog = this.dialog.open(WarningComponent, {
      width: '40%',
      data: this.message.getMessage('sign_processing_dialog.message_stop_sign')
    });
    dialog.afterClosed().subscribe(ref => {
      if (ref) {
        this.isCancel = true;
        this.userCancel = true;
        this.documentService.setCancelFlow(true);
        const data = {
          signMethod: this.typeSelectCertificate,
          contractId: this.document.id,
          mainContractAttachments: [],
          certificate: this.sign.certificate,
          hashKey: this.hashKey,
          tenantId: this.tenantId,
          signTransactionId: this.signTransactionId,
          userCancel: this.userCancel,
        };
        this.anonymousSignService.signCancel(data, this.contractIdAndContractEnterpriseIdEncode).subscribe(rs => {
          this.userCancel = false;
          this.errorStatus = "messages.stop_sign_document";
        });
      }
    })
  }

  signClose() {
    // this.imageData = this.contractSignEntityList;
  }

  async processSignOTPAfterDialogClose(signDialog: any, dialog: any, focusInput: any) {
    this.blockUI.reset();
    this.blockUI.start('');
    let signMethod = this.typeSelectCertificate;
    if (this.isShowEKYC) {
      if (this.ekycSupportConfig === 1) {
        signMethod = EnumSignMethod.SIGN_OTP_EKYC;
      } else if (this.ekycSupportConfig === 2) {
        signMethod = EnumSignMethod.SIGN_OTP_EKYC_ADVANCED;
      }
    }
    const sign = JSON.parse(JSON.stringify(this.sign));
    sign.signTransactionCode = this.commonService.generateUUID();
    sign.otp = signDialog.otp;
    sign.anonymousOtp = false;
    sign.transactionId = signDialog.transactionId;
    sign.contractId = signDialog.contractId;
    sign.signMethod = signMethod;
    sign.signPositions = JSON.stringify(this.signProcessing);
    sign.message = this.messageSign;
    if (this.contractIdAndContractEnterpriseIdEncode) {
      this.anonymousSignService.checkExpireTime(this.hashKey, this.tenantId, this.contractIdAndContractEnterpriseIdEncode).subscribe(res => {
        this.checkDisplayMessageError(res.code);
        if (!this.isError) {
          if (this.fileUpload) {
            sign.image = this.fileUpload;
            this.getApiSignImageSystem(this.anonymousSignService.signOtpWithImageBase64, sign, this.contractIdAndContractEnterpriseIdEncode);
          } else {
            this.anonymousSignService.signOtpNoImage(sign, this.contractIdAndContractEnterpriseIdEncode).toPromise().catch(err => {
              this.errorStatus = this.message.getMessage('messages.sign_fail');
            });
          }
          this.signingProcess(sign.signTransactionCode, dialog, focusInput);
        }
      });
    } else {
      if (this.fileUpload) {
        sign.image = this.fileUpload;
        this.getApiSignImageSystem(this.anonymousSignService.signOtpWithImageBase64, sign);
      } else {
        this.anonymousSignService.signOtpNoImage(sign).toPromise().catch(err => {
          this.errorStatus = this.message.getMessage('messages.sign_fail');
        });
      }
      this.signingProcess(sign.signTransactionCode, dialog, focusInput);
    }

  }

  onChangeSelectCertificate(value: any) {

  }

  getCertificateCloudCa() {
    // this.simCaPhoneNumber = this.digitalCertificateService.formatPhoneNumber(this.simCaPhoneNumber);
    this.anonymousSignService.getCertsCloudCa(this.hashKey, this.cloudCaUsername, this.providerName, this.contractIdAndContractEnterpriseIdEncode, this.tenantId).pipe(first()).subscribe(rs => {
      this.checkDisplayMessageError(rs.code);
      if (rs.data.length > 0) {
        this.cloudCaDataSource = rs.data.map((item, index) => {
          return {
            ...item,
            STT: index + 1
          };
        });
      } else {
        this.toastr.error(this.message.getMessage('validation.no_valid_certificate_cloudCA'));
      }
    }, error => {
    });
  }

  getQuantityEkycBeforeNext(): Observable<boolean> {
    this.blockUI.start('');
    return this.anonymousSignService.getQuantityEkyc(this.document.id, this.hashKey, this.tenantId)
      .pipe(map((res) => {
        let isNext = false;
        this.blockUI.stop();
        if (res.success === true && res.data) {
          if (this.ekycSupportConfig == 1 && res.data.quantityEkyc) isNext = true; //normal
          if (this.ekycSupportConfig == 2 && res.data.quantityAdvancedEkyc) isNext = true; //Advance
        } else {
          this.toastr.error(this.message.getMessage(res.message));
        }
        return isNext
      }))
  }

  async loadServiceType() {
    // console.log("serviceType", this.serviceTypeData);

    // this.serviceTypeData.allowImage ? this.allowImage = this.serviceTypeData.allowImage : this.allowImage = false;
    if (this.serviceTypeData && this.serviceTypeData.allowOtp) {
      this.allowOtp = this.serviceTypeData.allowOtp
    }

    if (this.serviceTypeData) {
      this.supportEkyc = !!Number(this.serviceTypeData.ekycSupportConfig);
      this.ekycSupportConfig = this.serviceTypeData.ekycSupportConfig;
      if (this.supportEkyc) {
        await this.getQuantityEkyc();
      }
    }
  }

  async getQuantityEkyc() {
    if (!this.document.id) return of(null);
    const res = await this.anonymousSignService.getQuantityEkyc(this.document.id, this.hashKey, this.tenantId).toPromise()
    if (res.success === true && res.data) {
      if (this.ekycSupportConfig == 1 && res.data.quantityEkyc) this.isStillQuantityEkyc = true; //normal
      if (this.ekycSupportConfig == 2 && res.data.quantityAdvancedEkyc) this.isStillQuantityEkyc = true; //Advance
      if (res.data.quantityEkyc) this.isQuantityEkyc = true;
      if (res.data.quantityAdvancedEkyc) this.isQuantityAdvancedEkyc = true;
    } else {
      this.toastr.error(this.message.getMessage(res.message));
    }
    // console.log("🚀 ~ file: sign-flow-document.component.ts ~ line 2167 ~ this.isStillQuantityEkyc", this.isStillQuantityEkyc)
    // if (!this.selectedCert.typeCertificate) {
    // this.selectFirstCertificate();
    // }
  }

  private onIdentityEKYC() {
    const dataImg = this.ekyc.getDataImage();
    if (!dataImg) return;
    let body = {
      typeImage: dataImg.typeImage,
      contractId: this.sign.contractId,
      images: dataImg.images.map(image => {
        return {base64Image: image.base64Image, type: image.type}
      })
    }
    // if (this.selectedCert.typeCertificate === this.signMethod.SIGN_NO_CERT) {
    //   this.ekycSupportWithoutImageNoCtsMb(body);
    // }
    if (this.typeSelectCertificate === this.signMethod.SIGN_OTP || this.typeSelectCertificate === this.signMethod.SIGN_NO_CERT) {
      this.validateEKYCOtp(body);
    }

    // if (this.selectedCert.typeCertificate === this.signMethod.SIGN_EKYC || this.selectedCert.typeCertificate === this.signMethod.SIGN_EKYC_ADVANCED) {
    //   this.signEkyc(body);
    // }
  }

  private validateEKYCOtp(body: any): void {
    this.blockUI.start('');
    this.anonymousSignService.valiadateEkycOtpSupport(body, this.hashKey, this.tenantId)
      .subscribe(res => {
        this.blockUI.stop();
        if (res && res.success) {
          if (this.typeSelectCertificate === this.signMethod.SIGN_OTP) {
            this.processSignOTP();
          } else if (this.typeSelectCertificate === this.signMethod.SIGN_NO_CERT) {
            this.processSignNoCertificate();
          }
        } else {
          if (res && !res.success) {
            // this.toastr.error(this.message.getMessage(res.message));
            let dialogRef;
            if (res.code === "0x002413")
              dialogRef = this.dialog.open(ConfirmResignEkycSupportComponent, {
                width: '350px',
                data: {message: this.message.getMessage('messages.sign_fail_ekyc'),}
              });
            else
              dialogRef = this.dialog.open(ConfirmResignEkycSupportComponent, {
                width: '350px',
                data: {message: this.message.getMessage('messages.confirm_resign_ekyc'),}
              });
            dialogRef.afterClosed().subscribe(rs => {
              // console.log(rs)
              if (rs) {
                this.isReloadCamera = true;
                setTimeout(x => {
                  this.isReloadCamera = false;
                }, 300);
              } else {
                if (this.contractIdAndContractEnterpriseIdEncode) {
                  if (this.isSignDigitalCertificate) {
                    this.router.navigate(['/approval/success']);
                  } else
                    this.router.navigate([`sign-anonymous/${this.hashKey}/${this.tenantId}/${this.contractIdAndContractEnterpriseIdEncode}/detail`], {});
                } else {
                  if (this.isSignDigitalCertificate) {
                    this.router.navigate(['/approval/success']);
                  } else
                    this.router.navigate([`/sign-anonymous/${this.hashKey}/${this.tenantId}/detail`], {});
                }
              }
            })
          }
        }
      })
  }

  private onNextEKYC(): void {
    this.next();
  }

  setTimetamMoney() {
    this.isClickSignBuuton = true;
    if (this.isSelectPosition) {
      this.toastr.error(this.message.getMessage('messages.need_choose_position'));
      this.blockUI.stop();
      this.blockUIStop = true;
      return;
    } else {
      this.blockUIStop = false;
    }
    if (this.document.mainContractAttachments && this.document.mainContractAttachments.length && (this.isShowImage || !this.isSignDigitalCertificate)) {
      const fileName = [];
      let indexError = null;
      let filePathError = null;
      const fileError = [];
      this.document.mainContractAttachments.forEach((ca, index) => {
        const fileId = this.decodeId(ca.id);
        const hasImage = this.signPosition.some(e => e.signType === SignPositionTypes.IMAGE);
        const sign = this.signPosition.filter(signData => {
          if (signData.fileId === fileId) {
            if (hasImage) {
              if (signData.signType !== SignPositionTypes.DIGITAL) {
                return signData;
              }
            } else {
              return signData;
            }
          }

        });
        if (!sign.length) {
          if (!indexError) {
            indexError = index;
            filePathError = ca.path;
          }
          fileError.push(ca.id);
          fileName.push(`'${ca.fileName}'`);
        }
      });
      if (fileName.length) {
        this.changeFile(filePathError, indexError);
        this.fileError = fileError;
        this.toastr.error(this.commonService.format(this.message.getMessage('messages.need_create_sign_file'), fileName.join(', ')).replace(/&quot;/g, "'"));
        this.blockUI.stop();
        this.blockUIStop = true;
        return;
      } else {
        this.blockUIStop = false;
      }
    }

    if (this.saveImageData.length == 0) {
      this.saveImageData = _.cloneDeep(this.imageData);
    } else
      this.imageData = this.saveImageData;

    const positionConvert = [];
    if (this.imageData && this.imageData.length > 0) {
      this.imageData.forEach(pos => {
        positionConvert.push({
          positionY: pos.positionY,
          pageNumber: pos.pageNumber,
          positionX: pos.positionX,
          widthRectangle: pos.widthRectangle,
          heightRectangle: pos.heightRectangle,
          signType: "combine"
        });
      });
    }

    this.sign = {
      ...this.selectedCert,
      hashKey: this.hashKey,
      tenantId: this.tenantId,
      phoneNumber: this.simCaPhoneNumber,
      contractId: this.document.id,
    };
    if (this.typeSelectCertificate === this.signMethod.SIGN_OTP) {
      this.sign.phoneNumber = this.otpPhoneNumber;
    }
    // const position = JSON.parse(localStorage.getItem('SignPosition'));
    // if (position) {
    //   let imageSort = [];
    //   for (const contractAttachment of this.document.mainContractAttachments) {
    //     const fileId = this.decodeId(contractAttachment.id);
    //     const imageData = position.filter(item => {
    //       item.positionX = item.x ? item.x : item.positionX ? item.positionX : null;
    //       item.positionY = item.y ? item.y : item.positionY ? item.positionY : null;
    //       item.widthRectangle = item.width ? item.width : item.widthRectangle ? item.widthRectangle : null;
    //       item.heightRectangle = item.height ? item.height : item.heightRectangle ? item.heightRectangle : null;
    //       return item.fileId === fileId
    //     });
    //     imageSort = imageSort.concat(imageData);
    //   }
    //   const imageData = imageSort.filter(item => { if (item.signType === 'combine') { item.signType = 'image'; } return item.signType !== 'digital' });
    //   this.signProcessing = JSON.parse(JSON.stringify(imageData));
    // } else {
    let preImageSort = [];
    // this.contractSignEntityList = _.cloneDeep(this.imageData);
    for (const contractAttachment of this.document.mainContractAttachments) {
      const fileId = this.decodeId(contractAttachment.id);
      if (!this.isShowImage && this.isSignDigitalCertificate) {
        let imageData = [
          {
            positionX: 1,
            positionY: 1,
            pageNumber: 1,
            signType: "image",
            widthRectangle: 0,
            heightRectangle: 0,
            zoom: 1,
            fileId: fileId,
          }
        ]
        preImageSort = preImageSort.concat(imageData);
      } else {
        const hasImage = this.imageData.some(e => e.signType === SignPositionTypes.IMAGE);
        const imageData = this.imageData.filter((signDataImage: any) => {
          if (signDataImage.fileId === fileId) {
            if (hasImage) {
              if (signDataImage.signType !== SignPositionTypes.DIGITAL) {
                return signDataImage;
              }
            } else {
              return signDataImage;
            }
          }
        });
        preImageSort = preImageSort.concat(imageData);
      }
    }
    const imageSort = _.cloneDeep(preImageSort);
    let imageData = []
    const arr1 = [];
    for (let i = 0; i < imageSort.length; i++) {
      for (let j = 0; j < imageSort.length; j++) {
        if (i !== j && imageSort[j].positionX == imageSort[i].positionX
          && imageSort[j].positionY == imageSort[i].positionY
          && imageSort[j].pageNumber == imageSort[i].pageNumber
          && imageSort[j].widthRectangle == imageSort[i].widthRectangle
          && imageSort[j].heightRectangle == imageSort[i].heightRectangle
          && imageSort[j].zoom == imageSort[i].zoom
          && imageSort[j].fileId == imageSort[i].fileId
          && imageSort[j].signType !== imageSort[i].signType) {
          if (imageSort[j].signType == 'image') {
            arr1.push(imageSort[j])
          } else {
            arr1.push(imageSort[i])
          }
          imageSort.splice(j, 1);
          imageSort.splice(i, 1);
          i--;
          break;
        }
      }
    }
    // arr1.map(item => item.signType = 'image')
    imageData = ([...imageSort, ...arr1]);
    let imagePreSort = [];
    //sort sign by file - pageNumber - positionY
    for (const contractAttachment of this.document.mainContractAttachments) {
      const fileId = this.decodeId(contractAttachment.id);
      let imageList = imageData.filter(item => {
        return item.fileId === fileId
      });
      imageList = imageList.sort((a, b) => a.pageNumber === b.pageNumber ?
        Number(b.positionY) - Number(a.positionY) :
        Number(a.pageNumber) - Number(b.pageNumber));
      imagePreSort = imagePreSort.concat(imageList);
    }
    this.signImages = imagePreSort.map((item) => {
      item['code'] = uuid.v4();
      return item;
    })
    this.signProcessing = JSON.parse(JSON.stringify(this.signImages));
  }

  getBodyTimeStampMoney() {
    const body = {
      signMethod: this.typeSelectCertificate,
      hashKey: this.hashKey,
      tenantId: this.tenantId,
      contractId: this.document.id,
      signPositions: this.signImages
    }
    if (this.contractIdAndContractEnterpriseIdEncode) {
      body['hashLink'] = this.contractIdAndContractEnterpriseIdEncode;
    }
    return body;
  }

  checkTimestampMoney() {
    if (this.isSelectPosition && (this.isShowImage || !this.isSignDigitalCertificate)) {
      this.toastr.error(this.message.getMessage('messages.need_choose_position'));
      this.blockUI.stop();
      return;
    }
    if (this.contractIdAndContractEnterpriseIdEncode) {
      this.anonymousSignService.checkExpireTime(this.hashKey, this.tenantId, this.contractIdAndContractEnterpriseIdEncode).subscribe(res => {
        this.checkDisplayMessageError(res.code);
        this.setTimetamMoney();
        if (this.blockUIStop) {
          this.blockUI.stop();
          return;
        }
        if (this.current === 3 && this.isShowEKYC) {
          this.onIdentityEKYC();
        } else if (this.typeSelectCertificate === this.signMethod.SIGN_OTP) {
          if (this.isShowEKYC && this.current === 2) {
            this.onNextEKYC()
          } else {
            this.processSignOTP()
          }
          // }else if(this.typeSelectCertificate === this.signMethod.SIGN_USB_TOKEN){
          //   this.createHash(this.usbTokenCertificate.certRawdata);
        } else {
          this.blockUI.reset();
          this.blockUI.start('');
          if (this.document.isConfirmBCT && this.typeSelectCertificate !== this.signMethod.SIGN_USB_TOKEN) {
            this.anonymousSignService.createTimestampMoney(this.getBodyTimeStampMoney()).subscribe(
              res => {
                this.checkDisplayMessageError(res.code);
                this.blockUI.stop();
                if (res && !res.success) {
                  if (res.code === ErrorCode.NotEnoughMoneyTimestamp)
                    this.openDialogOutOfMoneyOtp(this.message.getMessage('digital_certificate_management.out_of_money_timestamp'));
                  else
                    this.toastr.error(res.message)
                } else {
                  this.signTransactionId = res.data;
                  this.onClickSignButton()
                }
              }
            )
          } else {
            this.blockUI.reset();
            this.blockUI.start('');
            if (this.document.isConfirmBCT) {
              this.anonymousSignService.createTimestampMoney(this.getBodyTimeStampMoney()).subscribe(
                res => {
                  this.checkDisplayMessageError(res.code);
                  this.blockUI.stop();
                  if (res && !res.success) {
                    if (res.code === ErrorCode.NotEnoughMoneyTimestamp)
                      this.openDialogOutOfMoneyOtp(this.message.getMessage('digital_certificate_management.out_of_money_timestamp'));
                    else
                      this.toastr.error(res.message)
                  } else {
                    this.signTransactionId = res.data;
                    this.onClickSignButton()
                  }
                }
              )
            } else {
              this.blockUI.stop();
              this.onClickSignButton()
            }
          }
        }
      });
    } else {
      this.setTimetamMoney();
      if (this.blockUIStop) {
        this.blockUI.stop();
        return;
      }
      if (this.current === 3 && this.isShowEKYC) {
        this.onIdentityEKYC();
      } else if (this.typeSelectCertificate === this.signMethod.SIGN_OTP) {
        if (this.isShowEKYC && this.current === 2) {
          this.onNextEKYC()
        } else {
          this.processSignOTP()
        }
        // }else if(this.typeSelectCertificate === this.signMethod.SIGN_USB_TOKEN){
        //   this.createHash(this.usbTokenCertificate.certRawdata);
      } else {
        this.blockUI.reset();
        this.blockUI.start('');
        if (this.document.isConfirmBCT && this.typeSelectCertificate !== this.signMethod.SIGN_USB_TOKEN) {
          this.anonymousSignService.createTimestampMoney(this.getBodyTimeStampMoney()).subscribe(
            res => {
              this.checkDisplayMessageError(res.code);
              this.blockUI.stop();
              if (res && !res.success) {
                if (res.code === ErrorCode.NotEnoughMoneyTimestamp)
                  this.openDialogOutOfMoneyOtp(this.message.getMessage('digital_certificate_management.out_of_money_timestamp'));
                else
                  this.toastr.error(res.message)
              } else {
                this.signTransactionId = res.data;
                this.onClickSignButton()
              }
            }
          )
        } else {
          this.blockUI.reset();
          this.blockUI.start('');
          if (this.document.isConfirmBCT) {
            this.anonymousSignService.createTimestampMoney(this.getBodyTimeStampMoney()).subscribe(
              res => {
                this.checkDisplayMessageError(res.code);
                this.blockUI.stop();
                if (res && !res.success) {
                  if (res.code === ErrorCode.NotEnoughMoneyTimestamp)
                    this.openDialogOutOfMoneyOtp(this.message.getMessage('digital_certificate_management.out_of_money_timestamp'));
                  else
                    this.toastr.error(res.message)
                } else {
                  this.signTransactionId = res.data;
                  this.onClickSignButton()
                }
              }
            )
          } else {
            this.blockUI.stop();
            this.onClickSignButton()
          }
        }
      }
    }
  }

  signingProcess(signTransactionCode, dialog?: any, focusInput?: any) {
    clearInterval(this.signingInteval);
    setTimeout(() => {
      this.signingInteval = setInterval(() => {
        let request = {
          signTransactionCode: signTransactionCode,
          tenantId: this.tenantId,
          hashKey: this.hashKey
        }
        this.anonymousSignService.getStatusSign(request).subscribe(rs => {
          if (rs && rs.success && (rs.data.status == 'DONE' || rs.data.status == 'DAEMON_PROCESSING')) {
            this.isCallDone = true;
            this.signDocumentService.openSigningDialog.next(false);
            clearInterval(this.signingInteval);
            this.onSignSuccess();
          } else if (rs && rs.success && rs.data.status !== 'ERROR') {
            let arrayStatus = {};
            if (!this.openSigningDialog && this.typeSelectCertificate === this.signMethod.SIGN_OTP && rs.data.list[0].status == 'DONE') {
              this.signDocumentService.openSigningDialog.next(true);
              this.blockUI.stop();
              dialog.close(true);
            }
            for (let i = 0; i < rs.data.list.length; i++) {
              arrayStatus[rs.data.list[i].code] = rs.data.list[i].status;
            }
            for (let i = 0; i < this.signProcessing.length; i++) {
              this.signProcessing[i].done = arrayStatus[this.signProcessing[i].code] == 'DONE' ? true : false
            }
          } else if (rs.data && rs.data.status === 'ERROR') {
            if (!this.openSigningDialog && this.typeSelectCertificate === this.signMethod.SIGN_OTP) {
              this.toastr.error(rs.data.message)
              this.blockUI.stop();
              focusInput();
            } else {
              this.signDocumentService.openSigningDialog.next(false);
              this.errorStatus = "messages.stop_sign_document";
              this.signError = rs && rs.data.message ? rs.data.message : null;
            }
            clearInterval(this.signingInteval);
          }
        })
      }, 1000)
    }, 1000);
  }

  checkDisplayMessageError(code) {
    if (code && code === ErrorCode.NoAccessToContracts) {
      this.isError = true;
      //this.router.navigate([`/error`]);
      window.location.href = 'error';
      this.dialogRef.close();
    } else if (code && code === ErrorCode.ContractExpireTime) {
      this.isError = true;
      //this.router.navigate([`/expire`]);
      window.location.href = 'expire';
      this.dialogRef.close();
    } else {
      this.isError = false;
    }
  }

  checkExpireTime() {
    this.anonymousSignService.checkExpireTime(this.hashKey, this.tenantId, this.contractIdAndContractEnterpriseIdEncode).subscribe(res => {
      this.checkDisplayMessageError(res.code);
    });
  }

  disableNextButton() {
    if (this.current === 1) {
      if (this.indexSelect === 0) {
        if (this.imageSignConfig
          && (
            !this.imageSignConfig.allValid()
            || this.imageSignConfig.allValid() === 'non-check'
          )) {
          return true;
        }
      }
    }
    return this.isDisableNextButton || !this.checkAgree
  }

  getConfigKeyList(): string[] {
    return Object.keys(this.signConfig);
  }

  getUserConfig() {
    this.signDocumentService.getUserConfigAsync(true)
      .pipe(tap(res => {
          if (res.success && res.data) {
            for (const key in this.signConfig) {
              this.signConfig[key].enabled = res.data[key] || false;
            }

            this.signConfig.address.value = res.data['addressDetail'] || '';
            this.signConfig.position.value = res.data['positionDetail'] || '';
            this.signConfig.confirmBy.value = res.data['signature'] || '';
            this.signConfig.fontFamily.value = res.data['fontFamily'] || '';
            this.signConfig.fontWeight.value = res.data['fontWeight'] || '';
            this.signConfig.fontStyle.value = res.data['fontStyle'] || '';
            this.signConfig.signatureImageBase64.value = res.data['signatureImageBase64'] || '';
            this.signConfig.signatureImageName.value = res.data['signatureImageName'] || '';
            this.signConfig.signaturePosition.value = res.data['signaturePosition'] || '';
            this.signConfig.signatureRatio.value = res.data['signatureRatio'] || '';

            this.signConfig.fontFamily.enabled = false;
            this.signConfig.fontWeight.enabled = false;
            this.signConfig.fontStyle.enabled = false;
            this.signConfig.signatureImageBase64.enabled = false;
            this.signConfig.signatureImageName.enabled = false;
            this.signConfig.signaturePosition.enabled = false;
            this.signConfig.signatureRatio.enabled = false;

            this.signConfig.contentPosition.value = res.data['contentPosition'];
            this.signConfig.contentPosition.enabled = false;

            // console.log(this.signConfig);
          }
        }),
        switchMap(() => {
          return this.signDocumentService.getDateAsync();
        })
      ).subscribe(res => {
      if (res.success) {
        this.signConfig.signingTime.value = res.data.date;

        this.cd.detectChanges();
        setTimeout(() => {
          this.setFontSize(imageConfigViewScaleId);
          this.setFontSize(imageConfigRenderId);
        }, 100);
      }
    })
  }

  showConfig(key: string): boolean {
    if (key === 'greenTick') {
      return false
    }

    if (this.typeCertificate !== this.signMethod.SIGN_OTP) {
      if (key === 'phoneNumber') {
        this.signConfig.phoneNumber.enabled = false;
        return false;
      }
      if (key === 'confirmBy') {
        this.signConfig.confirmBy.enabled = false;
        return false;
      }
    } else {
      if (key === 'confirmBy' && this.scopeType !== 2) {
        this.signConfig.confirmBy.enabled = true;
        return true;
      } else if (key === 'confirmBy' && this.scopeType === 2) {
        this.signConfig.confirmBy.enabled = false;
        return false;
      }
    }

    return this.signConfig[key].enabled;
  }

  getApiSignImageSystem(api: any, ...body) {
    if (this.indexSelect === 0 && this.fileUpload) {
      this.signDocumentService.getDateAsync().subscribe(date => {
        this.signConfig.signingTime.value = date.data.date;

        this.cd.detectChanges();

        setTimeout(async () => {
          let blob = null;
          try {
            let imageSize = this.setSizeFrameImage();
            blob = await this.imageGenerateService.genImage(this.signConfig, imageSize).toPromise();
          } catch (e) {
            console.log("call api error, use html to image", e);
            try {
              let imageSize = this.setSizeFrameImage();
              blob = await this.imageGenerateService.genImage(this.signConfig, imageSize).toPromise();
            } catch (e) {
              console.log("call api error, use html to image", e);
            }
          }

          if(!blob){
            this.toastr.error(this.message.getMessage('messages.error_proccessing'));
            this.isError = true;
            //this.router.navigate([`/error`]);
            // window.location.href = 'error';
            this.dialogRef.close();
            return;
          }
          const file = new File([blob], 'lastImage.png', {type: 'image/png'});

          this.fileUpload = file;

          body[0].image = this.fileUpload;

          this.invokeSignApi(api, body);

        }, 300)
      })
    } else {
      this.invokeSignApi(api, body);
    }
  }

  // hàm cũ trả Observable, hàm Base64 trả Promise — gọi thống nhất ở đây
  invokeSignApi(api: any, ...body: any[]) {
    const rs = api(...body);
    if (rs && typeof rs.subscribe === 'function') {
      rs.subscribe((res) => {
        this.checkDisplayMessageError(res.code);
      });
    } else {
      rs.then((res) => {
        this.checkDisplayMessageError(res.code);
      }).catch(() => {
        this.errorStatus = this.message.getMessage('messages.sign_fail');
      });
    }
  }

  getNumber(value: any) {
    return value.split(':') || [];
  }

  setSizeFrameImage() {
    switch (this.signConfig.signaturePosition.value) {
      case 'left':
      case 'right':
        return {
          width: '370px',
          height: '136px'
        };
      case 'top':
      case 'bottom':
        return {
          width: '300px',
          height: '237px'
        };

      default:
        return {
          width: '300px',
          height: '136px'
        };
    }
  }

  setFontSize(id: string) {
    const listElement: any = document.getElementsByClassName(id);
    // console.log(listElement);
    for (const el of listElement) {
      this.setSizetext(id, el);
    }
  }

  setSizetext(id: string, el: any) {
    if (!el) {
      return;
    }
    el.style.wordBreak = 'break-word';
    if (id === imageConfigViewScaleId) {
      if (el && el.lastElementChild && el.lastElementChild.lastElementChild)
        el = el.lastElementChild.lastElementChild as HTMLElement;
    }

    if (el) {
      let fontSize = 56;
      let minSize = 32;
      let padding = 40;
      if (id === imageConfigFormPreviewId) {
        fontSize /= 4;
        minSize /= 4;
        padding /= 4;
      }

      // console.log(el);
      el.style.fontSize = fontSize + 'px';

      let parent;
      if (this.signConfig.signaturePosition.value === 'top' || this.signConfig.signaturePosition.value === 'bottom') {
        parent = el.parentElement;
      } else {
        parent = el.parentElement.parentElement;
      }
      const parentHeight = parent.offsetHeight;
      let height = el.offsetHeight;

      while (height > parentHeight - padding && fontSize > minSize) {
        if (id === imageConfigFormPreviewId) {
          fontSize -= 1 / 4;
        } else {
          fontSize--;
        }
        el.style.fontSize = fontSize + 'px';
        height = el.offsetHeight;
      }
    }
  }
}


interface SimCaDataItem {
  STT: number;
  certificateName: string;
  serialNumber: string;
  taxCode: string;
  activeDate: any;
  expireDate: any;
  isUsed: boolean;
  checked: boolean;
  email: string;
}


interface CloudCaDataItem {
  STT: number;
  certificateName: string;
  cloudCaUserId: string;
  serialNumber: string;
  taxCode: string;
  activeDate: any;
  expireDate: any;
  isUsed: boolean;
  checked: boolean;
  email: string;
}
